import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  FormControl,
  FormLabel,
  Modal,
  Row,
} from "react-bootstrap";
//import BootstrapTable from "react-bootstrap-table-next";
import BootstrapTable from "fad-react-bootstrap-table-next";
//import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import "fad-react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

//import cellEditFactory from "react-bootstrap-table2-editor";

import { AsyncTypeahead, Loader, Typeahead } from "react-bootstrap-typeahead";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import NumberFormat from "react-number-format";
import { NumericFormat } from "react-number-format";

import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/ds.js";
import { KeyConstants } from "../ds/Key_Constants";
import { LookupResultDetails } from "../ds/lookup_ds.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  AddIcon,
  CalendarIcon,
  CLOSEICON,
  CollapseMaximizeIcon,
  CollapseMinimizeIcon,
  ERRORICON,
  FilterIcon,
  RefreshIcon,
  SearchImageIcon,
  SUCCESSICON,
  AUTHENTICATION,
  Authentication,
} from "./Icons.js";
import {
  focusNextElement,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  scrollToElement,
  dateFormate,
} from "./Util.js";

export const customEventObject = (fieldName, selectedValue) => {
  let t = { name: fieldName, value: selectedValue };
  let e = { target: t };
  return e;
};

export class TextBlock_FW extends React.Component {
  constructor(props) {
    super(props);
    this.state = { textValue: this.props.value };
  }

  render() {
    return (
      <FormLabel className="text-block-container">
        {this.state.textValue}
      </FormLabel>
    );
  }
}

class InputCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.lookupRef = React.createRef();
    this.componentRef = React.createRef();
    this.state = {
      checked: this.props.checked,
      label: "",
      disableLabel: this.props.disableLabel,
    };
  }
  componentDidMount() {
    if (this.props.checked == true) {
      this.setState({
        label: "Yes",
      });
    } else {
      this.setState({
        label: "No",
      });
    }
    this.setState({ checked: this.props.checked });
  }
  componentDidUpdate() {
    if (this.props.checked !== this.state.checked) {
      if (this.props.checked == true) {
        this.setState({
          label: "Yes",
        });
      } else {
        this.setState({
          label: "No",
        });
      }
      this.setState({ checked: this.props.checked });
    }
  }

  handleFocus = (event) => {
    event.target.select();
  };

  handleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      focusNextElement();
    }
  };

  handleOnChange = (event) => {
    let isChecked = event.target.checked;
    this.setState({ checked: isChecked });

    let tempEventObejct = customEventObject(this.props.name, isChecked);
    this.props.onChange(tempEventObejct);
    if (isChecked == true) {
      this.setState({
        label: "Yes",
      });
    } else {
      this.setState({
        label: "No",
      });
    }
  };

  render() {
    return (
      <>
        {this.props.lable && (
          <label className="col-sm-12">{this.props.lable}</label>
        )}
        {!this.props.disableLabel ? (
          <FormCheck
            // className="form-check"
            type="checkBox"
            {...this.props}
            label={this.state.label}
            checked={this.state.checked}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocus}
            onChange={this.handleOnChange}
            disabled={this.props.disabled}
          />
        ) : (
          <FormCheck
            className="cstm-check"
            type="checkBox"
            {...this.props}
            // label={this.state.label}
            checked={this.state.checked}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocus}
            onChange={this.handleOnChange}
            disabled={this.props.disabled}
          />
        )}
        {/* <FormCheck
          // className="form-check"
          type="checkBox"
          {...this.props}
          label={this.state.label}
          checked={this.state.checked}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onChange={this.handleOnChange}
          disabled={this.props.disabled}
        /> */}
      </>
    );
  }
}

class InputTextbox extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.lookupRef = React.createRef();
    this.componentRef = React.createRef();

    this.state = {
      textValue: this.props.value,
      isReadOnly: this.props.readOnly,
      currentRowIndex: 0,
      activeSuggestion: 0,
      showSuggestions: true,
      isPossible: false,
      previousValue: "",
      isOnChangeOccurs: false,
    };
    this.isOnChangeOccurs = false;

    /*
    let disabled = false;
    if (this.state.isDisabled !== true) {
      if (this.props.disabled == "" || this.props.disabled == null) {
        disabled = this.props.readOnly;
      } else {
        disabled = this.props.disabled;
      }
    } else {
      disabled = this.state.isDisabled;
    }
    */
  }

  componentDidUpdate_v1() {
    if (this.props.value !== this.state.textValue)
      this.setState({ textValue: this.props.value });
    // if (this.props.value !== this.state.textValue)
    //   this.setState({ previousValue: this.props.value });
  }

	componentDidUpdate(prevProps) {
	  if (prevProps.value !== this.props.value) {
		this.setState({ textValue: this.props.value });
	  } else if (
		this.props.value &&                           
		this.state.textValue !== this.props.value    
	  ) {
		this.setState({ textValue: this.props.value });
	  }
	}

  componentDidMount() {
    this.modifyTextBox();
    if (this.props.value !== this.state.textValue)
      this.setState({ textValue: this.props.value });
    // if (this.props.value !== this.state.textValue)
    //   this.setState({ previousValue: this.props.value });
  }

  modifyTextBox = () => {
    if (this.props.isModifyView != null) {
      if (this.props.isModifyView) {
        if (this.props.isModifyEditable != null) {
          if (this.props.isModifyEditable) {
            this.setState({
              isReadOnly: this.props.isModifyEditable,
              isDisabled: this.props.isModifyEditable,
            });
          } else {
            this.setState({
              //isReadOnly: !this.props.isModifyView,
              isDisabled: !this.props.isModifyView,
              isReadOnly: !this.props.isModifyView,
            });
          }
        } else {
          this.setState({
            //isReadOnly: !this.props.isModifyView,
            isDisabled: !this.props.isModifyView,
            isReadOnly: !this.props.isModifyView,
          });
        }
      } else {
        if (this.props.isModifyEditable != null) {
          this.setState({
            isReadOnly: this.props.isModifyEditable,
            isDisabled: this.props.isModifyEditable,
          });
        }
      }
    }
  };

  clear() {
    this.setState({ textValue: "" });
  }

  handleFocus = (event) => {
    if (
      this.props.enableAutoCompleteTextBox === true &&
      this.props.enableAutoCompleteTextBox != undefined
    ) {
      this.props.displayAutoCompleteList(true);
      this.setState({ activeSuggestion: 0 });
    }
    this.componentRef.current.select();
  };

  focus = () => {
    this.componentRef.current.focus();
  };

  enterKeyHandler = (e) => {
    if (this.isOnChangeOccurs) {
      this.state.previousValue = "";
      this.setState({ previousValue: "" });
    }

    if (e.target.value && e.target.value !== this.state.previousValue) {
      this.props.enterKeyEventHandler(e);
    }

    this.setState({
      previousValue: e.target.value,
    });

    // reset flag AFTER handling
    this.isOnChangeOccurs = false;

    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);
  };

  enterKeyHandler_bkup = (e) => {
    if (this.state.isOnChangeOccurs) this.state.previousValue = "";

    const previousValue = this.state.previousValue;

    if (
      e.target.value != null &&
      e.target.value != undefined &&
      e.target.value != ""
    ) {
      // if (this.state.textValue != previousValue) {
      if (e.target.value != previousValue) {
      
        this.props.enterKeyEventHandler(e);
      }
      // this.setState({
      //   previousValue: e.target.value,
      // });
    }
    this.setState({
      previousValue: e.target.value,
    });
    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);
  };

  setPreviousValue = (event) => {

    this.setState({
      previousValue: event.target.value,
    });
  };
  onChange_og = (event) => {
    // this.state.isOnChangeOccurs = true;
    this.isOnChangeOccurs = true;
    if (this.props.onChange) this.props.onChange(event);
    // this.setState({
    //   isOnChangeOccurs: true,
    // });

    // this.setPreviousValue(event);
  };


// onChange = (event) => {
//   const cursorPos = event.target.selectionStart;
//   const value = event.target.value;

//   this.setState({ textValue: value }, () => {
//     if (this.componentRef.current) {
//       this.componentRef.current.setSelectionRange(cursorPos, cursorPos);
//     }
//   });

//   if (this.props.onChange) this.props.onChange(event);
// };

onChange = (event) => {
  const cursorPos = event.target.selectionStart;
  const value = event.target.value;

  // Mark that user typed manually, so previousValue gets cleared on next enterKey
  this.isOnChangeOccurs = true;

  this.setState({ textValue: value }, () => {
    if (this.componentRef.current) {
      this.componentRef.current.setSelectionRange(cursorPos, cursorPos);
    }
  });

  if (this.props.onChange) this.props.onChange(event);
};
  handleKeyDown = (event) => {
    const { showAutoCompleteList } = this.props;

    if (
      event.keyCode == KeyConstants.ENTER_KEY ||
      event.keyCode === KeyConstants.TAB_KEY
    ) {
      if (
        this.props.enableAutoCompleteTextBox === true &&
        !isEmptyArray(this.props.autoCompleteListData) &&
        showAutoCompleteList === true
      ) {
        let dataList = this.props.autoCompleteListData;
        let currentRow = dataList[this.state.currentRowIndex];
        if (
          this.props.enterKeyEventHandler &&
          currentRow != undefined &&
          currentRow != null
        ) {
          let targetFieldName = event.target.name;
          let code = currentRow.code;

          let t = { name: targetFieldName, value: code };
          const e = { target: t };
          this.enterKeyHandler(e);
          this.setState({ activeSuggestion: 0 });
        }
      } else {
        if (this.props.enterKeyEventHandler) {
          this.enterKeyHandler(event);
          this.setState({
            isPossible: false,
          });
        }
      }
      setTimeout(() => {
        this.focus();
        focusNextElement();
      }, 100);

      //this.componentRef.current.blur(); // COMMENTED BY GURU
    }

    if (event.keyCode == KeyConstants.F2_KEY) {
      if (this.props.lookupRequired === true) {
        this.handleLookup();
      }
    }

    // up key for autocomplete
    if (
      this.props.enableAutoCompleteTextBox === true &&
      showAutoCompleteList === true
    ) {
      if (event.keyCode === KeyConstants.UP_ARROW_KEY) {
        //up key
        let currentRowIndex = this.state.currentRowIndex - 1;
        let dataList = this.props.autoCompleteListData;
        if (dataList) {
          if (currentRowIndex < 0) {
            currentRowIndex = dataList.length - 1;
            if (currentRowIndex < 0) currentRowIndex = 0;
          }
        } else {
          currentRowIndex = 0;
        }
        this.setState({ currentRowIndex: currentRowIndex });
        this.scrollToRow(currentRowIndex);
        event.preventDefault();
        this.setState({ activeSuggestion: currentRowIndex });
      }

      if (event.keyCode === KeyConstants.DOWN_ARROW_KEY) {
        //down key
        let currentRowIndex = this.state.currentRowIndex + 1;
        let dataList = this.props.autoCompleteListData;
        if (dataList) {
          if (currentRowIndex >= dataList.length) {
            currentRowIndex = 0;
          }
        } else {
          currentRowIndex = 0;
        }
        this.setState({ currentRowIndex: currentRowIndex });
        this.scrollToRow(currentRowIndex);
        event.preventDefault();
        this.setState({ activeSuggestion: currentRowIndex });
      }
    }

    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  };

  scrollToRow = (currentRowIndex) => {
    let rowId = "row-" + currentRowIndex;
    scrollToElement(rowId);
  };

  handleLookup = () => {
    if (this.lookupRef.current) {
		this.lookupRef.current.showLookup();
	} else {
		this.props.showToast?.("Lookup is not ready yet. Please try again.", "warning");
	}
  };

  onBlur = (event) => {
    if (this.props.valueChangeOnBlur == true) {
      let tempEventObejct = customEventObject(
        this.props.name,
        this.state.textValue,
      );
      if (
        this.props.onValueChangeOnBlur != null &&
        this.props.onValueChangeOnBlur != undefined
      )
        this.props.onValueChangeOnBlur(tempEventObejct);
      this.setState({
        previousValue: tempEventObejct.target.value,
      });
    }
    if (
      this.props.enableAutoCompleteTextBox === true &&
      this.props.enableAutoCompleteTextBox != undefined
    ) {
      setTimeout(() => {
        this.props.displayAutoCompleteList(false);
      }, 100);
      this.setState({ activeSuggestion: 0, currentRowIndex: 0 });
      //this.props.displayAutoCompleteList(false);
    }
    if (this.state.isPossible === true) {
      if (
        this.props.enterKeyEventHandler != null &&
        this.props.enterKeyEventHandler != undefined
      ) {
        this.enterKeyHandler(event);
      }
    } else {
      this.setState({
        isPossible: false,
      });
    }
  };

  lookupValueSelected = async (selectedValue) => {
    this.isOnChangeOccurs = true;
    await this.setState({ textValue: selectedValue });
    this.lookupRef.current.closeLookup();

    if (
      this.props.displayAutoCompleteList != null &&
      this.props.displayAutoCompleteList != undefined
    ) {
      this.props.displayAutoCompleteList(false);
    }
    let tempEventObejct = customEventObject(this.props.name, selectedValue);
    if (
      this.props.onValueChangeOnBlur != null &&
      this.props.onValueChangeOnBlur != undefined
    )
      this.props.onValueChangeOnBlur(tempEventObejct);

    if (this.props.onChange != null && this.props.onChange != undefined)
      this.props.onChange(tempEventObejct);
    if (this.props.selectButtonClick != null) {
      this.props.selectButtonClick();
    }
    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);

    let event = new Event("change");
    let eventTarget = new EventTarget(this.props.name);
    eventTarget.name = this.props.name;
    eventTarget.value = selectedValue;
    eventTarget.dispatchEvent(event);
    if (
      this.props.enterKeyEventHandler != null &&
      this.props.enterKeyEventHandler != undefined
    ) {
      this.enterKeyHandler(event);
    }
  };

  // onAutoCompleteLiClick = (event) => {

  //   let code = event.target.getAttribute("code");

  //   let targetFieldName = event.target.name;
  //   let t = { name: targetFieldName, value: code };
  //   const target = { target: t };
  //   this.enterKeyHandler(target);
  //   setTimeout(() => {
  //     this.focus();
  //     focusNextElement();
  //   }, 100);
  // };



onAutoCompleteLiClick = (event) => {
  // Walk up to the <li> element in case event.target is the text node child
  const li = event.target.closest("li");
  if (!li) return;

  const code = li.getAttribute("code");

  // Use this.props.name — <li> elements have no name attribute
  const targetFieldName = this.props.name;

  // Force-clear previousValue so re-selecting the same value always fires
  this.isOnChangeOccurs = true;
  this.setState({ previousValue: "", currentRowIndex: 0, activeSuggestion: 0 });

  const t = { name: targetFieldName, value: code };
  const target = { target: t };

  this.enterKeyHandler(target);

  setTimeout(() => {
    this.focus();
    focusNextElement();
  }, 100);
};

  render() {
    let activeSuggestion = this.state.activeSuggestion;
    let showSuggestions = this.props.showAutoCompleteList;
    let isNotFound = false;
    isNotFound = this.props.isNotFound;
    let isMandatory = false;
    if (this.props.isMandatory != null && this.props.isMandatory != undefined)
      isMandatory = this.props.isMandatory;

    let suggestionsListComponent;
    if (
      !isEmpty(this.props.autoCompleteListData) &&
      this.props.autoCompleteListData != undefined &&
      showSuggestions
    ) {
      suggestionsListComponent = (
        <ul className="autoCompleteOptions">
          {this.props.autoCompleteListData.map((option, index) => {
            let className;
            if (index === activeSuggestion) {
              className = "suggestion-active";
            }
            return (
              <li
                ref={this.myRef}
                id={"row-" + index}
                className={className}
                key={option.code}
                onClick={this.onAutoCompleteLiClick}
                code={option.code}
                onMouseDown={this.onAutoCompleteLiClick}
              >
                {option.code + "-" + option.description}
              </li>
            );
          })}
        </ul>
      );
    }

    let disabled = false;
    if (this.state.isDisabled !== true) {
      if (this.props.disabled == "" || this.props.disabled == null) {
        disabled = this.props.readOnly;
      } else {
        disabled = this.props.disabled;
      }
    } else {
      disabled = this.state.isDisabled;
    }
    let style = {};
    if (isNotFound && isMandatory) {
      style = {
        border: "2px solid red",
        backgroundColor: "#DF69B9",
        color: "#FFFFFF",
        // backgroundColor: "#C7F6B6",
      };
    } else if (isNotFound && !isMandatory) {
      style = {
        border: "2px solid red",
      };
    } else if (!isNotFound && isMandatory) {
      style = {
        // backgroundColor: "#E3F2C1",
        // backgroundColor: "#d8f8dd",
        backgroundColor: "#E3F2C1",
        // D0F5BE // F6FFDE
      };
    } else if (!isNotFound && !isMandatory) {
      style = {};
    }
    return (
      <div className="text-box-container">
        <FormControl
          ref={this.componentRef}
          type="text"
          {...this.props}
          value={this.state.textValue}
          style={style}
          onChange={this.onChange}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onBlur={this.onBlur}
          readOnly={disabled}
          disabled={disabled}
          autoComplete="off"
        />

        {this.props.enableAutoCompleteTextBox === true &&
        this.props.autoCompleteListData != null &&
        showSuggestions === true &&
        !isEmptyString(this.state.textValue)
          ? suggestionsListComponent
          : null}
        {this.props.enableAutoComplete === true ? (
          <Button
            tabIndex={-1}
            onClick={this.handleLookup}
            disabled={this.state.isDisabled}
          >
            <SearchImageIcon />
          </Button>
        ) : null}
        {(this.props.lookupRequired === true &&
          this.props.disabled === false) ||
        (this.props.lookupRequired === true &&
          this.props.disabled === undefined) ? (
          <Button
            tabIndex={-1}
            onClick={this.handleLookup}
            disabled={this.state.isDisabled}
          >
            <SearchImageIcon />
          </Button>
        ) : null}
        {!!this.props.lookupHandler ? (
          <LookupDialog
            tabIndex={-1}
            //popupLvlClass={"popupSizeLevel4"}
            lookupHandler={this.props.lookupHandler}
            onLookupValueSelected={this.lookupValueSelected}
            value={this.state.textValue}
            ref={this.lookupRef}
          />
        ) : null}
      </div>
    );
  }
}


class InputTextbox_old_bkup_30Mar2026 extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.lookupRef = React.createRef();
    this.componentRef = React.createRef();

    this.state = {
      textValue: this.props.value,
      isReadOnly: this.props.readOnly,
      currentRowIndex: 0,
      activeSuggestion: 0,
      showSuggestions: true,
      isPossible: false,
      previousValue: "",
      isOnChangeOccurs: false,
    };

    /*
    let disabled = false;
    if (this.state.isDisabled !== true) {
      if (this.props.disabled == "" || this.props.disabled == null) {
        disabled = this.props.readOnly;
      } else {
        disabled = this.props.disabled;
      }
    } else {
      disabled = this.state.isDisabled;
    }
    */
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.textValue)
      this.setState({ textValue: this.props.value });
    // if (this.props.value !== this.state.textValue)
    //   this.setState({ previousValue: this.props.value });
  }

  componentDidMount() {
    this.modifyTextBox();
    if (this.props.value !== this.state.textValue)
      this.setState({ textValue: this.props.value });
    // if (this.props.value !== this.state.textValue)
    //   this.setState({ previousValue: this.props.value });
  }

  modifyTextBox = () => {
    if (this.props.isModifyView != null) {
      if (this.props.isModifyView) {
        if (this.props.isModifyEditable != null) {
          if (this.props.isModifyEditable) {
            this.setState({
              isReadOnly: this.props.isModifyEditable,
              isDisabled: this.props.isModifyEditable,
            });
          } else {
            this.setState({
              //isReadOnly: !this.props.isModifyView,
              isDisabled: !this.props.isModifyView,
              isReadOnly: !this.props.isModifyView,
            });
          }
        } else {
          this.setState({
            //isReadOnly: !this.props.isModifyView,
            isDisabled: !this.props.isModifyView,
            isReadOnly: !this.props.isModifyView,
          });
        }
      } else {
        if (this.props.isModifyEditable != null) {
          this.setState({
            isReadOnly: this.props.isModifyEditable,
            isDisabled: this.props.isModifyEditable,
          });
        }
      }
    }
  };

  clear() {
    this.setState({ textValue: "" });
  }

  handleFocus = (event) => {
    if (
      this.props.enableAutoCompleteTextBox === true &&
      this.props.enableAutoCompleteTextBox != undefined
    ) {
      this.props.displayAutoCompleteList(true);
      this.setState({ activeSuggestion: 0 });
    }
    this.componentRef.current.select();
  };

  focus = () => {
    this.componentRef.current.focus();
  };

  enterKeyHandler = (e) => {
    if (this.state.isOnChangeOccurs) this.state.previousValue = "";
    const previousValue = this.state.previousValue;

    // console.log("previousValue *___* :: ", this.state.previousValue);
    // console.log("e.target.value *___* :: ", e.target.value);
    // console.log("textValue *___* :: ", this.state.textValue);
    if (
      e.target.value != null &&
      e.target.value != undefined &&
      e.target.value != ""
    ) {
      // if (this.state.textValue != previousValue) {
      if (e.target.value != previousValue) {
        // console.log(" not same *___* :: ", e.target.value, "||", previousValue);
        this.props.enterKeyEventHandler(e);
      }
      // this.setState({
      //   previousValue: e.target.value,
      // });
    }
    this.setState({
      previousValue: e.target.value,
    });
    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);
  };

  setPreviousValue = (event) => {
    // console.log("setPreviousValue event *___* :: ", event.target.value);
    this.setState({
      previousValue: event.target.value,
    });
  };
  onChange = (event) => {
    if (this.props.onChange) this.props.onChange(event);
    this.setState({
      isOnChangeOccurs: true,
    });
    // this.setPreviousValue(event);
  };

  handleKeyDown = (event) => {
    const { showAutoCompleteList } = this.props;

    if (
      event.keyCode == KeyConstants.ENTER_KEY ||
      event.keyCode === KeyConstants.TAB_KEY
    ) {
      if (
        this.props.enableAutoCompleteTextBox === true &&
        !isEmptyArray(this.props.autoCompleteListData) &&
        showAutoCompleteList === true
      ) {
        let dataList = this.props.autoCompleteListData;
        let currentRow = dataList[this.state.currentRowIndex];
        if (
          this.props.enterKeyEventHandler &&
          currentRow != undefined &&
          currentRow != null
        ) {
          let targetFieldName = event.target.name;
          let code = currentRow.code;

          let t = { name: targetFieldName, value: code };
          const e = { target: t };
          this.enterKeyHandler(e);
          this.setState({ activeSuggestion: 0 });
        }
      } else {
        if (this.props.enterKeyEventHandler) {
          this.enterKeyHandler(event);
          this.setState({
            isPossible: false,
          });
        }
      }
      setTimeout(() => {
        this.focus();
        focusNextElement();
      }, 100);

      //this.componentRef.current.blur(); // COMMENTED BY GURU
    }

    if (event.keyCode == KeyConstants.F2_KEY) {
      if (this.props.lookupRequired === true) {
        this.handleLookup();
      }
    }

    // up key for autocomplete
    if (
      this.props.enableAutoCompleteTextBox === true &&
      showAutoCompleteList === true
    ) {
      if (event.keyCode === KeyConstants.UP_ARROW_KEY) {
        //up key
        let currentRowIndex = this.state.currentRowIndex - 1;
        let dataList = this.props.autoCompleteListData;
        if (dataList) {
          if (currentRowIndex < 0) {
            currentRowIndex = dataList.length - 1;
            if (currentRowIndex < 0) currentRowIndex = 0;
          }
        } else {
          currentRowIndex = 0;
        }
        this.setState({ currentRowIndex: currentRowIndex });
        this.scrollToRow(currentRowIndex);
        event.preventDefault();
        this.setState({ activeSuggestion: currentRowIndex });
      }

      if (event.keyCode === KeyConstants.DOWN_ARROW_KEY) {
        //down key
        let currentRowIndex = this.state.currentRowIndex + 1;
        let dataList = this.props.autoCompleteListData;
        if (dataList) {
          if (currentRowIndex >= dataList.length) {
            currentRowIndex = 0;
          }
        } else {
          currentRowIndex = 0;
        }
        this.setState({ currentRowIndex: currentRowIndex });
        this.scrollToRow(currentRowIndex);
        event.preventDefault();
        this.setState({ activeSuggestion: currentRowIndex });
      }
    }

    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  };

  scrollToRow = (currentRowIndex) => {
    let rowId = "row-" + currentRowIndex;
    scrollToElement(rowId);
  };

  handleLookup = () => {
    this.lookupRef.current.showLookup();
  };

  onBlur = (event) => {
    if (this.props.valueChangeOnBlur == true) {
      let tempEventObejct = customEventObject(
        this.props.name,
        this.state.textValue,
      );
      if (
        this.props.onValueChangeOnBlur != null &&
        this.props.onValueChangeOnBlur != undefined
      )
        this.props.onValueChangeOnBlur(tempEventObejct);
      this.setState({
        previousValue: tempEventObejct.target.value,
      });
    }
    if (
      this.props.enableAutoCompleteTextBox === true &&
      this.props.enableAutoCompleteTextBox != undefined
    ) {
      setTimeout(() => {
        this.props.displayAutoCompleteList(false);
      }, 100);
      this.setState({ activeSuggestion: 0, currentRowIndex: 0 });
      //this.props.displayAutoCompleteList(false);
    }
    if (this.state.isPossible === true) {
      if (
        this.props.enterKeyEventHandler != null &&
        this.props.enterKeyEventHandler != undefined
      ) {
        this.enterKeyHandler(event);
      }
    } else {
      this.setState({
        isPossible: false,
      });
    }
  };

  lookupValueSelected = async (selectedValue) => {
    await this.setState({ textValue: selectedValue });
    this.lookupRef.current.closeLookup();

    if (
      this.props.displayAutoCompleteList != null &&
      this.props.displayAutoCompleteList != undefined
    ) {
      this.props.displayAutoCompleteList(false);
    }
    let tempEventObejct = customEventObject(this.props.name, selectedValue);
    if (
      this.props.onValueChangeOnBlur != null &&
      this.props.onValueChangeOnBlur != undefined
    )
      this.props.onValueChangeOnBlur(tempEventObejct);

    if (this.props.onChange != null && this.props.onChange != undefined)
      this.props.onChange(tempEventObejct);
    if (this.props.selectButtonClick != null) {
      this.props.selectButtonClick();
    }
    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);

    let event = new Event("change");
    let eventTarget = new EventTarget(this.props.name);
    eventTarget.name = this.props.name;
    eventTarget.value = selectedValue;
    eventTarget.dispatchEvent(event);
    if (
      this.props.enterKeyEventHandler != null &&
      this.props.enterKeyEventHandler != undefined
    ) {
      this.enterKeyHandler(event);
    }
  };

  onAutoCompleteLiClick = (event) => {
    let code = event.target.getAttribute("code");
    let targetFieldName = event.target.name;
    let t = { name: targetFieldName, value: code };
    const target = { target: t };
    this.enterKeyHandler(target);
    setTimeout(() => {
      this.focus();
      focusNextElement();
    }, 100);
  };

  render() {
    let activeSuggestion = this.state.activeSuggestion;
    let showSuggestions = this.props.showAutoCompleteList;
    let isNotFound = false;
    isNotFound = this.props.isNotFound;
    let isMandatory = false;
    if (this.props.isMandatory != null && this.props.isMandatory != undefined)
      isMandatory = this.props.isMandatory;

    let suggestionsListComponent;
    if (
      !isEmpty(this.props.autoCompleteListData) &&
      this.props.autoCompleteListData != undefined &&
      showSuggestions
    ) {
      suggestionsListComponent = (
        <ul className="autoCompleteOptions">
          {this.props.autoCompleteListData.map((option, index) => {
            let className;
            if (index === activeSuggestion) {
              className = "suggestion-active";
            }
            return (
              <li
                ref={this.myRef}
                id={"row-" + index}
                className={className}
                key={option.code}
                onClick={this.onAutoCompleteLiClick}
                code={option.code}
                onMouseDown={this.onAutoCompleteLiClick}
              >
                {option.code + "-" + option.description}
              </li>
            );
          })}
        </ul>
      );
    }

    let disabled = false;
    if (this.state.isDisabled !== true) {
      if (this.props.disabled == "" || this.props.disabled == null) {
        disabled = this.props.readOnly;
      } else {
        disabled = this.props.disabled;
      }
    } else {
      disabled = this.state.isDisabled;
    }
    let style = {};
    if (isNotFound && isMandatory) {
      style = {
        border: "2px solid red",
        backgroundColor: "#DF69B9",
        color: "#FFFFFF",
        // backgroundColor: "#C7F6B6",
      };
    } else if (isNotFound && !isMandatory) {
      style = {
        border: "2px solid red",
      };
    } else if (!isNotFound && isMandatory) {
      style = {
        // backgroundColor: "#E3F2C1",
        // backgroundColor: "#d8f8dd",
        backgroundColor: "#E3F2C1",
        // D0F5BE // F6FFDE
      };
    } else if (!isNotFound && !isMandatory) {
      style = {};
    }
    return (
      <div className="text-box-container">
        <FormControl
          ref={this.componentRef}
          type="text"
          {...this.props}
          value={this.state.textValue}
          style={style}
          onChange={this.onChange}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onBlur={this.onBlur}
          readOnly={disabled}
          disabled={disabled}
          autoComplete="off"
        />

        {this.props.enableAutoCompleteTextBox === true &&
        this.props.autoCompleteListData != null &&
        showSuggestions === true &&
        !isEmptyString(this.state.textValue)
          ? suggestionsListComponent
          : null}
        {this.props.enableAutoComplete === true ? (
          <Button
            tabIndex={-1}
            onClick={this.handleLookup}
            disabled={this.state.isDisabled}
          >
            <SearchImageIcon />
          </Button>
        ) : null}
        {(this.props.lookupRequired === true &&
          this.props.disabled === false) ||
        (this.props.lookupRequired === true &&
          this.props.disabled === undefined) ? (
          <Button
            tabIndex={-1}
            onClick={this.handleLookup}
            disabled={this.state.isDisabled}
          >
            <SearchImageIcon />
          </Button>
        ) : null}
        {!!this.props.lookupHandler ? (
          <LookupDialog
            tabIndex={-1}
            //popupLvlClass={"popupSizeLevel4"}
            lookupHandler={this.props.lookupHandler}
            onLookupValueSelected={this.lookupValueSelected}
            value={this.state.textValue}
            ref={this.lookupRef}
          />
        ) : null}
      </div>
    );
  }
}

class InputNumberTextbox extends React.Component {
  constructor(props) {
    super(props);
    this.lookupRef = React.createRef();
    this.componentRef = React.createRef();
    this.state = { textValue: this.props.value };
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.textValue)
      this.setState({ textValue: this.props.value });
  }

  handleFocus = (event) => {
    event.target.select();
  };

  focus = () => {
    this.componentRef.current.focus();
  };

  handleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      focusNextElement();
    }
    if (event.keyCode == KeyConstants.F2_KEY) {
      if (this.props.lookupRequired === true) {
        this.handleLookup();
      }
    }
    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    }
  };

  handleLookup = () => {
    this.lookupRef.current.showLookup();
  };

  lookupValueSelected = async (selectedValue) => {
    await this.setState({ textValue: selectedValue });
    this.lookupRef.current.closeLookup();

    let tempEventObejct = customEventObject(this.props.name, selectedValue);
    this.props.onChange(tempEventObejct);
  };

  onBlur = (event) => {
    if (this.props.onBlur != null && this.props.onBlur != undefined)
      this.props.onBlur(event);
  };

  render() {
    return (
      <div className="text-box-container">
        <input
          type="text"
          pattern="[0-9]*"
          ref={this.componentRef}
          {...this.props}
          value={this.state.textValue}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onBlur={this.onBlur}
        />
      </div>
    );
  }
}

export class AutoCompleteTextbox extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.state = { textValue: this.props.value };
  }

  clear = () => {
    this.componentRef.current.clear();
    this.setState({ textValue: "" });
  };

  focus = () => {
    this.componentRef.current.focus();
  };

  handleKeyDown = (event) => {
    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    } else {
      if (event.keyCode == KeyConstants.ENTER_KEY) {
        focusNextElement();
        this.componentRef.current.blur();
      }
    }
    //focusNextElement();
  };

  onBlur = (event) => {
    if (this.props.onBlur != null && this.props.onBlur != undefined)
      this.props.onBlur(event);
  };

  componentDidUpdate = () => {
    let defaultValue = this.props.defaultValue;
    let selectedValue = [];
    if (!!defaultValue) {
      if (!!this.props.lookupValues && this.props.lookupValues.size > 0) {
        selectedValue = this.props.lookupValues.filter(
          (ent) => ent[this.props.valuePropery] === defaultValue,
        );
      } else {
        let tempObj = {};
        tempObj[this.props.valuePropery] = defaultValue;
        tempObj[this.props.descriptionProperty] = defaultValue;
        selectedValue.push(tempObj);
      }
      this.state.textValue = selectedValue;
      this.componentRef.current.blur();
    } else {
      //
    }
  };

  componentDidMount = () => {
    let defaultValue = this.props.defaultValue;
    let selectedValue = [];

    if (!!defaultValue && !!this.props.lookupValues) {
      selectedValue = this.props.lookupValues.filter(
        (ent) => ent[this.props.valuePropery] === defaultValue,
      );
      //textValue = selectedValue[0][this.props.valuePropery];
    }
    this.setState({ textValue: selectedValue });
  };

  componentDidMount_bkup_10Mar2021 = () => {
    let defaultValue = this.props.defaultValue;
    let selectedValue = [];

    if (!!defaultValue && !!this.props.lookupValues) {
      selectedValue = this.props.lookupValues.filter(
        (ent) => ent[this.props.valuePropery] === defaultValue,
      );
      //textValue = selectedValue[0][this.props.valuePropery];
    }
    this.setState({ textValue: selectedValue });
  };

  valueSelected = async (selectedValue) => {
    let textValue = "";
    if (!!selectedValue) {
      if (selectedValue.length > 0) {
        textValue = selectedValue[0][this.props.valuePropery];
      }
    }
    await this.setState({ textValue: selectedValue });

    let tempEventObejct = customEventObject(this.props.name, textValue);
    this.props.onChange(tempEventObejct);
  };

  autoCompleteDefaultMenuRender = (option) => {
    return (
      <div>
        <span>{option[this.props.valuePropery]}</span>
        <span>
          <small> | {option[this.props.descriptionProperty]}</small>{" "}
        </span>
      </div>
    );
  };

  filterByFields = [this.props.valuePropery, this.props.descriptionProperty];
  render() {
    return (
      <Typeahead
        align="left"
        ref={this.componentRef}
        filterBy={this.filterByFields}
        id="id1"
        name={this.props.name}
        labelKey={this.props.valuePropery}
        onChange={this.valueSelected}
        options={this.props.lookupValues}
        placeholder={this.props.placeholder}
        selected={this.state.textValue}
        readOnly={this.props.readOnly}
        onKeyDown={this.handleKeyDown}
        onBlur={this.onBlur}
        disabled={this.props.disabled}
        renderMenuItemChildren={(option) => (
          <div className="autocomplete-menu-item">
            <div className="autocomplete-menu-item-value">
              {option[this.props.valuePropery]}
            </div>
            <div className="autocomplete-menu-item-description">
              {option[this.props.descriptionProperty]}
            </div>
          </div>
        )}
      />
    );
  }
}

export class DynamicAutoCompleteTextbox extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.state = {
      selectedValue: this.props.value,
    };
  }

  handleKeyDown = (event) => {
    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    event.persist();
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    } else {
      if (event.keyCode == KeyConstants.ENTER_KEY) {
        focusNextElement();
        this.componentRef.current.blur();
      }
    }
  };

  componentDidMount = () => {
    let defaultValue = this.props.defaultValue;
    let selectedValue = [];
    if (!!defaultValue) {
      if (!!this.props.lookupValues && this.props.lookupValues.size > 0) {
        selectedValue = this.props.lookupValues.filter(
          (ent) => ent[this.props.valuePropery] === defaultValue,
        );
      } else {
        let tempObj = {};
        tempObj[this.props.valuePropery] = defaultValue;
        tempObj[this.props.descriptionProperty] = defaultValue;
        selectedValue.push(tempObj);
      }
      this.setState({ selectedValue: selectedValue });
    } else {
      //
    }
  };

  componentDidUpdate = () => {
    let defaultValue = this.props.defaultValue;
    if (this.props.isResetValues) {
      this.componentRef.current.clear();
      this.state.selectedValue = [];
    }

    let selectedValue = [];

    if (this.props.isResetValues) {
      this.componentRef.current.clear();
      this.state.selectedValue = [];
    }

    if (!!defaultValue) {
      if (!!this.props.lookupValues && this.props.lookupValues.size > 0) {
        selectedValue = this.props.lookupValues.filter(
          (ent) => ent[this.props.valuePropery] === defaultValue,
        );
      } else {
        let tempObj = {};
        tempObj[this.props.valuePropery] = defaultValue;
        tempObj[this.props.descriptionProperty] = defaultValue;
        selectedValue.push(tempObj);
      }
      this.state.selectedValue = selectedValue;
      this.componentRef.current.blur();
    } else {
      //
    }
  };

  clearValue = () => {
    this.setState({ selectedValue: [] });
  };

  focus = () => {
    this.componentRef.current.focus();
  };

  valueSelected = async (selectedValue) => {
    let textValue = "";
    if (!!selectedValue) {
      if (selectedValue.length > 0) {
        textValue = selectedValue[0][this.props.valuePropery];
      }
    }
    await this.setState({ selectedValue: selectedValue });

    let tempEventObejct = customEventObject(this.props.name, textValue);
    this.props.onChange(tempEventObejct);
  };

  filterBy = () => true;

  render() {
    let defaultValue = this.props.defaultValue;
    let lookuValues = this.props.lookupValues;

    return (
      <AsyncTypeahead
        id="id1"
        ref={this.componentRef}
        name={this.props.name}
        minLength={3}
        isLoading={this.props.isLoading}
        onSearch={this.props.handleSearch}
        labelKey={this.props.valuePropery}
        onChange={this.valueSelected}
        options={lookuValues}
        filterBy={this.filterBy}
        placeholder={this.props.placeholder}
        selected={this.state.selectedValue}
        readOnly={this.props.readOnly}
        onKeyDown={this.handleKeyDown}
        disabled={this.props.disabled}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        renderMenuItemChildren={(option) => (
          <div className="autocomplete-menu-item">
            <div className="autocomplete-menu-item-value">
              {option[this.props.valuePropery]}
            </div>
            <div className="autocomplete-menu-item-description">
              {option[this.props.descriptionProperty]}
            </div>
          </div>
        )}
      />
    );
  }
}

export class DataGrid extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  toDataGridColumn = (columnDef) => {
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let isCenter = columnDef.columnAlignment == 2 ? true : false;
    let tableHeaderAlign = "left";
    if (isRight) tableHeaderAlign = "right";
    else if (isCenter) tableHeaderAlign = "center";
    let tempDataGridColumnDef = {
      name: columnDef.columnDisplayName,
      selector: columnDef.columnBindingPropertyName,
      sortable: true,
      right: isRight,
      minWidth: columnDef.columnMinWidth,
      maxWidth: columnDef.columnMaxWidth,
      tableHeaderAlign: tableHeaderAlign,
    };

    if (columnDef.imageColumn === true) {
      let cellDef = (row) => (
        <img
          src={this.onImageLinkCallBack(columnDef, row)}
          width={50}
          height={30}
          mode="fit"
        />
      );
      tempDataGridColumnDef.cell = cellDef;
    }
    if (columnDef.hyperLinkcolumn === true) {
      let cellDef = (row) => (
        <span
          className="dataGridHyperLink"
          data-tag="allowRowEvents"
          onClick={(evt) => this.onHyperLinkClick(evt, columnDef, row)}
        >
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }

    if (columnDef.statusColumn === true) {
      let cellDef = (row) => (
        <span>
          {this.getStatusCaption(
            columnDef,
            row[columnDef.columnBindingPropertyName],
          )}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }

    return tempDataGridColumnDef;
  };

  onHyperLinkClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      let selectedValue = e.target.innerText;
      if (!!columnDef.hyperLinkCallback) {
        columnDef.hyperLinkCallback(selectedValue, rowData);
      }
    }
  };

  onRowClicked = (e) => {};

  onImageLinkCallBack = (columnDef, rowData) => {
    if (!!columnDef.imageLinkCallBack) {
      // return columnDef.imageLinkCallBack(rowData);
      return columnDef.imageLinkCallBack(columnDef, rowData);
    }
  };

  getStatusCaption = (columnDef, status) => {
    if (!!columnDef.getStatusCaption) {
      let finalStatus = columnDef.getStatusCaption(status);
      return finalStatus;
    }
  };
  customStyles = {
    table: {
      style: {
        height: "400px",
        width: "100%",
        ScrollX: false,
        overflow: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "80%",
        borderCollapse: "collapse",
        verticalAlign: "middle !important",
      },
    },
    rows: {
      style: {
        minHeight: "20px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#ddd",
        color: "white",
      },
      stripedStyle: {
        color: "#000",
        backgroundColor: "#e9ecef",
      },
    },
    button: {
      default: "#5482AE",
    },
    headRow: {
      style: {
        textAlign: "center",
        backgroundColor: "#655f80",
        paddingTop: "2px",
        paddingBottom: "2px",
        minHeight: "2rem",
        borderBottomWidth: "1px",
        borderBottomColor: "#fff",
        borderBottomStyle: "2px solid #fff",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        paddingRight: "5px",
        paddingLeft: "5px",
      },
      activeSortStyle: {
        color: "#fff",
        "&:focus": {
          outline: "none",
        },
        "&:hover:not(:focus)": {
          color: "#fff",
        },
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: "#fff",
        },
        "&:hover": {
          color: "#fff",
        },
      },
    },
  };
  render() {
    let dataGridColumnList = [];
    if (this.props.columnsList) {
      this.props.columnsList.map((cdef) =>
        dataGridColumnList.push(this.toDataGridColumn(cdef)),
      );
    }

    let noDataComponent = (
      <DataTableNoDataComponent isLoading={this.props.isLoading} />
    );

    return (
      <DataTable
        customStyles={this.customStyles}
        ref={this.componentRef}
        keys={this.props.keys}
        columns={dataGridColumnList}
        striped={true}
        highlightOnHover={true}
        data={this.props.dataList}
        noDataComponent={noDataComponent}
        onRowClicked={this.onRowClicked}
        persistTableHead
      />
    );
  }
}

export class DataTableNoDataComponent extends React.Component {
  render() {
    let output = "No Data";
    if (this.props.isLoading) {
      output = "Loading... Pleae Wait!";
    }
    return <div className="dataGridNoDataComponent">{output}</div>;
  }
}

export class DataGridColumnDefinition {
  constructor() {
    this.columnDisplayName = "";
    this.columnBindingPropertyName = "";
    // this.sortable = false;
    // this.headerColumnAlignment = 2;
    this.columnAlignment = 0; // 0 -->Left  1-->Right  2-->Center

    this.hyperLinkcolumn = false;
    //this.textBoxColumn = false;
    //this.checkBoxColumn = false;
    this.hyperLinkCallback = null;
    this.imageColumn = false;
    this.imageLinkCallBack = null;
    this.columnMinWidth = "";
    this.columnMaxWidth = "";
    this.inputBoxColumn = false;
    this.inputBoxTargetColumnName = "";
    this.inputChangeCallback = null;
    this.buttonColumn = false;
    this.buttonClickCallback = null;
    this.columnDisabled = false;

    this.checkBoxColumn = false;
    this.checkBoxClickCallback = null;

    this.statusColumn = false;
    this.getStatusCaption = null;

    this.graphColumn = false;
    this.graphValueProvider = null;

    this.inputBoxOnBlurCallback = null;

    this.columnStyle = "";
	
    this.isCalculated = false;
    this.getCalculatedValue = null;
  }

  setDetails = (
    columnDisplayName,
    columnBindingPropertyName,
    // sortable = false,
    // headerColumnAlignment = 2,
    columnAlignment = 0,
    hyperLinkcolumn = false,
    hyperLinkCallback = null,
    // checkBoxColumn = false,
    //checkBoxClickCallback = null,
    imageColumn = false,
    imageLinkCallBack = null,
    columnMinWidth,
    columnMaxWidth,
    statusColumn = false,
    getStatusCaption = null,
    graphColumn = false,
    graphValueProvider = null,
    columnStyle,
  ) => {
    this.columnDisplayName = columnDisplayName;
    this.columnBindingPropertyName = columnBindingPropertyName;
    // this.sortable = sortable;
    // this.headerColumnAlignment = headerColumnAlignment;
    this.columnAlignment = columnAlignment;
    this.hyperLinkcolumn = hyperLinkcolumn;
    this.hyperLinkCallback = hyperLinkCallback;
    //  this.checkBoxColumn = checkBoxColumn;
    //this.checkBoxClickCallback = checkBoxClickCallback;
    this.imageColumn = imageColumn;
    this.imageLinkCallBack = imageLinkCallBack;
    this.columnMinWidth = columnMinWidth;
    this.columnMaxWidth = columnMaxWidth;
    this.statusColumn = statusColumn;
    this.getStatusCaption = getStatusCaption;
    this.graphColumn = graphColumn;
    this.graphValueProvider = graphValueProvider;
    this.columnStyle = columnStyle;
    return this;
  };

  setEditableDetails = (
    inputBoxColumn = false,
    inputBoxTargetColumnName = "",
    inputChangeCallback = null,
    buttonColumn = false,
    buttonClickCallback = null,
    checkBoxColumn = false,
    checkBoxClickCallback = null,
    inputBoxOnBlurCallback = null,
  ) => {
    this.inputBoxColumn = inputBoxColumn;
    this.inputBoxTargetColumnName = inputBoxTargetColumnName;
    this.inputChangeCallback = inputChangeCallback;
    this.buttonColumn = buttonColumn;
    this.buttonClickCallback = buttonClickCallback;
    this.checkBoxColumn = checkBoxColumn;
    this.checkBoxClickCallback = checkBoxClickCallback;
    this.inputBoxOnBlurCallback = inputBoxOnBlurCallback;
    return this;
  };
  
  setCalculatedDetails = (isCalculated, getCalculatedValue) => {
	  this.isCalculated = isCalculated;
	  this.getCalculatedValue = getCalculatedValue;
	  return this;
	};  

  setDisabled = (columnDisabled = false) => {
    this.columnDisabled = columnDisabled;
    return this;
  };
}

const CollapseComponent = ({ isOpen, onClick }) => {
  return (
    <Button
      onClick={onClick}
      size="sm"
      tabindex="-1"
      className="custom_collapsable_button"
    >
      {isOpen ? <CollapseMinimizeIcon /> : <CollapseMaximizeIcon />}
    </Button>
  );
};

export const Lookup = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  // const element = document.querySelector('.bqjPGM');
  // if (element) {
  //   element.style.padding = '0';
  // }

  const closeModal = () => {
    props.closeAlertModalCallBack(false);
    setOpen(false);
  };
  return (
    <>
      <div>
        <Popup
          id="searchLookup"
          ref={props.parentRef}
          open={open}
          closeOnDocumentClick={false}
          onClose={closeModal}
          repositionOnResize={true}
          position="center center"
          className="searchLookup"
          nested={true}
          z-index={1000}
        >
          <div className="modal">
            <button className="close" onClick={closeModal}>
              &times;
            </button>

            <div className="moduleContainer" id="moduleContainer">
              <div className="modalHeaderWithButtons">
                <div className="modalButtonContainer modalLeftSideHeader">
                  {props.headerButtonContainer && (
                    <div>{props.headerButtonContainer}</div>
                  )}
                </div>
                <div className="modalTitle">{props.title}</div>
                <div className="modalRightSideHeader"></div>
              </div>
              <div className="content">
                <div className="header-cnt">{props.headercontent}</div>
                <div className="page-cnt"> {props.paginationContent}</div>
                <div className="result-cnt"> {props.resultContent}</div>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    </>
  );
};

class LookupDialog extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    let tempLookupData = null;
    this.loadDataFromServiceFlag = false;
    if (!!this.props.lookupHandler) {
      tempLookupData = this.props.lookupHandler.lookupdata;
      this.loadDataFromServiceFlag =
        this.props.lookupHandler.lookupDataCallback != null;
    }
    this.paginationFlag = false;
    if (!!this.props.paginationFlag) {
      this.paginationFlag = this.props.paginationFlag;
    }
    this.valueColumnName = "code";
    this.state = {
      filterText: "",
      lookupdata: tempLookupData,
      pageResultDetails: new LookupResultDetails(),
      showDataTable: false,
      showCriteriaView: this.props.lookupHandler.lookupCriteriaView,
      pageList: new PageListBean(),
      searchCriteria: this.props.lookupHandler.lookupCriteria,
      selectedValue: "",
      isCriteriaOpen: false,
      isShowLookup: false,
      value: this.props.value,
      //value: "",
      isCriteriaReset: false,
      currentRowIndex: 0,
      isFirst: true,
      // resetCriteria: null,
      isGenericLookup: false,
      isShowResultLookup: false,
    };
    this.skyLightDialogRef = React.createRef();
    this.searchCriteriaRef = React.createRef();
    this.criteriaViewRef = React.createRef();
    this.resultGridRef = React.createRef();
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this._isMounted = true;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.value) {
      if (this.state.value != "") {
        this.setState({ value: this.props.value });
      }
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  updateResultCallBack = (lookup_result_details) => {
    if (this._isMounted) {
      this.setState({
        lookupdata: lookup_result_details.pageData,
        pageResultDetails: lookup_result_details,
        currentRowIndex: 0,
      });
      if (
        lookup_result_details.isGenericLookup != null &&
        lookup_result_details.isGenericLookup != undefined
      ) {
        this.state.isGenericLookup = lookup_result_details.isGenericLookup;
        this.setState({
          isGenericLookup: lookup_result_details.isGenericLookup,
          isShowResultLookup: true,
        });
      }
    }
  };

  setFocusOnResultGrid = () => {
    if (this.resultGridRef.current) this.resultGridRef.current.focus();
    this.setState({ isShowResultLookup: true });
  };

  generateLookupColumns = () => {
    let lookupColumnsList = [];
    if (!!this.props.lookupHandler) {
      for (let columnDef of this.props.lookupHandler.lookupColumnDefinitions) {
        lookupColumnsList.push(this.toLookupColumn(columnDef));
      }
    }
    return lookupColumnsList;
  };

  toLookupColumn = (columnDef) => {
    // console.log("toLookupColumn #", columnDef);
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let lookupColumnDef = {
      name: columnDef.columnDisplayName,
      selector: (row) => row[columnDef.columnBindingPropertyName],
      // selector: columnDef.columnBindingPropertyName,
      sortable: true,
      right: isRight,
      // width: "fit-content",
      // width: "140px !important",
      wrap: true,
    };
    // console.log("toLookupColumn lookupColumnDef #", lookupColumnDef);
    if (columnDef.valueColumn === true) {
      this.valueColumnName = columnDef.columnBindingPropertyName;
      let cellDef = (row) => (
        <span className="lookupLink" onClick={this.valueSelected}>
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      lookupColumnDef.cell = cellDef;
      lookupColumnDef.ignoreRowClick = true;
    }

    return lookupColumnDef;
  };

  toLookupColumn_old = (columnDef) => {
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let lookupColumnDef = {
      name: columnDef.columnDisplayName,
      selector: columnDef.columnBindingPropertyName,
      sortable: true,
      right: isRight,
    };

    if (columnDef.valueColumn === true) {
      this.valueColumnName = columnDef.columnBindingPropertyName;
      let cellDef = (row) => (
        <span className="lookupLink" onClick={this.valueSelected}>
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      lookupColumnDef.cell = cellDef;
      lookupColumnDef.ignoreRowClick = true;
    }

    return lookupColumnDef;
  };

  valueSelected = (e) => {
    let selectedValue = e.target.innerText;

    if (!!this.props.onLookupValueSelected) {
      this.setState({ selectedValue: selectedValue });
      this.props.onLookupValueSelected(selectedValue);
    }
  };
  // customStyles = {
  //   table: {
  //     style: {
  //       height: "400px",
  //       width: "100%",
  //       ScrollX: false,
  //       overflow: "auto",
  //       zIndex: 1,
  //     },
  //   },
  //   rows: {
  //     style: {
  //       minHeight: "20px",
  //     },
  //     highlightOnHoverStyle: {
  //       backgroundColor: "rgba(140, 140, 140, 0.9)",
  //       color: "white",
  //     },
  //     stripedStyle: {
  //       color: "#000",
  //       backgroundColor: "#f9f9f9",
  //     },
  //   },
  // };
  customStyles = {
    // body: {
    //   style: {
    //     overflowY: "hidden",
    //   },
    // },
    table: {
      style: {
        height: "58vh",
        width: "100%",
        ScrollX: false,
        overflow: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "80%",
        borderCollapse: "collapse",
        verticalAlign: "middle !important",
        padding: "1rem",
        zIndex: 1,
        // cursor: "pointer",
      },
    },
    header: {
      style: {
        display: "none",
      },
    },
    cells: {
      style: {
        paddingTop: "5px",
        paddingBottom: "5px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#fff",
        // backgroundColor: "blue",
        width: "130px !important",
        // whiteSpace: "pre !important",
        // textWrap: "auto !important",
        // overflow: "visible !important",
      },
    },
    rows: {
      style: {
        minHeight: "20px",

        "&:hover": {
          // cursor: "pointer",
          // backgroundColor: "rgba(140, 140, 140, 0.9)",
          backgroundColor: "#ddd",
          // color: "white",
        },
      },
      denseStyle: {
        minHeight: "0px",
      },
      highlightOnHoverStyle: {
        // backgroundColor: "#ddd",
        // color: "white",
        // backgroundColor: "rgba(140, 140, 140, 0.9)",
        // color: "white",
        // "&:hover": {
        //   cursor: "pointer",
        // },
      },
      stripedStyle: {
        color: "#000",
        backgroundColor: "#e9ecef",
      },
    },

    pagination: {
      style: {
        color: "#000000",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
      pageButtonsStyle: {
        color: "#000",
        backgroundColor: "transparent",
      },
    },

    button: {
      default: "#5482AE",
    },
    headRow: {
      style: {
        backgroundColor: "#655f80",
        minHeight: "2rem",
        top: "-16px",
        position: "relative",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        paddingRight: "5px",
        paddingLeft: "5px",
        borderRight: "2px solid #fff",
        // backgroundColor: "red",
      },
      activeSortStyle: {
        color: "#fff",
        "&:focus": {
          outline: "none",
        },
        "&:hover:not(:focus)": {
          color: "#fff",
        },
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: "#fff",
        },
        "&:hover": {
          color: "#fff",
        },
      },
    },
  };

  showLookup = () => {
    document.body.style.overflow = "hidden";
    if (this.props.lookupHandler.lookupCriteria) {
      if (this.props.value) {
        let result = this.props.value.toUpperCase();
        if ("NEW" !== result && this.props.value.length >= 3) {
          this.loadDataFromServiceFlag = false;
        }
        this.setState({
          isShowLookup: true,
          showDataTable: true,
          isCriteriaOpen: true,
        });
      } else {
        this.setState({
          // isShowResultLookup: true,
          isShowLookup: true,
          showDataTable: true,
          isCriteriaOpen: true,
        });
      }
      setTimeout(() => {
        if (
          this.props.lookupHandler.lookupCriteriaView &&
          this.searchCriteriaRef.current !== null
        ) {
          if (this.criteriaViewRef.current)
            this.criteriaViewRef.current.focusRef.current.focus();
        }
      }, 500);
    } else {
      this.showLookupWithCriteriaAndValue();
      this.setState({
        isShowResultLookup: true,
        isShowLookup: true,
        showDataTable: true,
        // isCriteriaOpen: true,
      });
      setTimeout(() => {
        if (
          this.props.lookupHandler.lookupCriteriaView &&
          this.searchCriteriaRef.current !== null
        ) {
          if (this.criteriaViewRef.current)
            this.criteriaViewRef.current.focusRef.current.focus();
        }
      }, 500);
      setTimeout(() => {
        this.setFocusOnResultGrid();
      }, 500);
    }
  };

  closeLookup = async () => {
    await this.setState({
      showDataTable: false,
      //lookupdata: null,
      filterText: "",
      //value: "",
      isShowLookup: false,
      searchCriteria: this.props.lookupHandler.lookupCriteria,
      lookupdata: this.props.lookupHandler.lookupdata,
      //searchCriteria: this.props.lookupHandler.newCriteria,
      pageResultDetails: [],
      isShowResultLookup: false,
    });
    document.body.style.overflow = "unset";
  };

  executeFilter = (e) => {
    e.preventDefault();
    let filterText = e.target.value.toUpperCase();
    this.setState({ filterText: filterText });

    if (e.target.value === "") {
      this.resetFilter();
    }
  };

  filterList = (pageNumber) => {
    let criteria = this.state.searchCriteria;
    // let criteria = this.props.lookupHandler.lookupCriteria;
    let filterText = this.state.filterText;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (criteria != null) {
      this.showLookupWithPaginationAndCriteria(
        pageNumber,
        criteria,
        filterText,
      );
    } else {
      this.FilterAttributeList(filterText);
    }
    setTimeout(() => {
      this.setFocusOnResultGrid();
    }, 500);
  };
  FilterAttributeList = (filterText) => {
    let lookupDataList = [];
    const filteredArray = this.state.lookupdata.filter(
      (item) =>
        item.code.includes(filterText) || item.description.includes(filterText),
    );
    if (!isEmptyArray(filteredArray)) lookupDataList = filteredArray;
    this.setState({ lookupdata: lookupDataList });
  };
  handleClear = () => {
    const { resetPaginationToggle, filterText } = this.state;

    if (this.state.filterText) {
      this.setState({
        resetPaginationToggle: !resetPaginationToggle,
        filterText: "",
      });
    }
  };

  resetFilter = (e) => {
    let criteria = this.state.searchCriteria;
    this.setState({ filterText: "", value: "" });
    this.resetCriteria();
    let lookupData = this.props.lookupHandler.lookupdata;
    this.setState({ lookupdata: lookupData });
    this.state.value = "";
    // e.preventDefault();
    setTimeout(() => {
      this.setFocusOnResultGrid();
    }, 500);
  };

  showLookupWithCriteria = (searchCriteria) => {
    if (this.loadDataFromServiceFlag) {
      this.props.lookupHandler.lookupDataCallback(this, 0, searchCriteria);
    } else {
      this.props.lookupHandler.fetchDataFromService(
        this,
        0,
        searchCriteria,
        // this.props.value
        this.state.filterText,
      );
    }
    this.setState({
      isShowLookup: true,
      showDataTable: true,
      criteriaOpen: false,
    });
  };

  showLookupWithCriteriaAndValue = () => {
    if (this.loadDataFromServiceFlag) {
      this.props.lookupHandler.lookupDataCallback(
        this,
        0,
        this.props.lookupHandler.lookupCriteria,
        null,
      );
    } else {
      this.props.lookupHandler.fetchDataFromService(
        this,
        0,
        this.props.lookupHandler.lookupCriteria,
        this.state.filterText,
      );
    }
    this.setState({
      isShowLookup: false,
      isShowResultLookup: true,
      showDataTable: true,
      criteriaOpen: false,
    });
  };

  searchCriteriaCallBack = (searchCriteria) => {
    this.setState({
      searchCriteria: searchCriteria,
      isCriteriaOpen: false,
      isShowLookup: false,
    });
    this.showLookupWithCriteria(searchCriteria);
    setTimeout(() => {
      this.setFocusOnResultGrid();
    }, 500);
  };

  renderCriteria = () => {
    const CriteriaView = this.props.lookupHandler.lookupCriteriaView;

    if (CriteriaView !== null && CriteriaView !== undefined) {
      return (
        <Popup
          ref={this.searchCriteriaRef}
          open={this.state.isCriteriaOpen}
          closeOnDocumentClick={false}
          repositionOnResize={true}
          position="center center"
          className="criteriaLookup"
          id="criteriaLookup"
          lockScroll={true}
          nested={true}
        >
          <div className="modal">
            <button className="close" onClick={this.closeCriteriaModal}>
              &times;
            </button>

            <div className="moduleContainer" id="moduleContainer">
              <div className="modalHeaderWithButtons">
                <div className="modalButtonContainer modalLeftSideHeader"></div>
                <div className="modalTitle">{"Search Criteria"}</div>
                <div className="modalRightSideHeader"></div>
              </div>
              <div className="content">
                {" "}
                <CriteriaView
                  ref={this.criteriaViewRef}
                  searchCriteria={this.state.searchCriteria}
                  searchCriteriaCallBack={this.searchCriteriaCallBack}
                />
              </div>
            </div>
          </div>
        </Popup>
      );
    } else {
      return <></>;
    }
  };

  closeCriteriaModal = () => {
    this.setState({ isCriteriaOpen: false });
  };

  handleAfterClose = () => {
    this.clearLookupData();
    if (this.criteriaViewRef.current)
      this.criteriaViewRef.current.clearCriteria();
  };

  clearLookupData() {
    //for empty the lookup data & set and focus elements
    let emptyArray = new Array();
    this.setState({
      lookupdata: emptyArray,
      showDataTable: false,
    });
  }

  /* pagination */

  showLookupWithPaginationAndCriteria = (pageNumber, criteria, filterText) => {
    if (this.loadDataFromServiceFlag) {
      this.props.lookupHandler.lookupDataCallback(
        this,
        pageNumber,
        criteria,
        filterText,
      );
    } else {
      this.props.lookupHandler.fetchDataFromService(
        this,
        pageNumber,
        criteria,
        filterText,
      );
    }
    this.setState({
      isShowLookup: true,
      showDataTable: true,
      isCriteriaOpen: false,
    });
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.searchCriteria;
    let value = "";
    if (this.state.value == "NEW") {
      value = "";
    } else {
      value = this.state.value;
    }
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.showLookupWithPaginationAndCriteria(
      pageNumber,
      criteria,
      this.state.filterText,
    );
    setTimeout(() => {
      this.setFocusOnResultGrid();
    }, 500);
  };

  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageResultDetails.currentPageNumber;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageResultDetails.currentPageNumber;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageResultDetails.pageSize;
    let totalCount = this.state.pageResultDetails.totalRecordsCount;
    let totalPages = totalCount / pageSize;
    totalPages += parseInt(totalCount % pageSize == 0 ? 0 : 1);
    this.loadPage(totalPages);
  };

  resetCriteria = (e) => {
    let resetCriteriaFromLookupHandler = this.props.lookupHandler.resetCriteria;
    let newCriteriaFromLookupHandler = this.props.lookupHandler.newCriteria;
    this.setState({
      searchCriteria: this.props.lookupHandler.searchCriteria,
      value: "",
      filterText: "",
    });
    //empty the textbox value
    if (this.criteriaViewRef.current)
      this.criteriaViewRef.current.clearCriteria(); // call the handler function using ref.

    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    this.showLookupWithPaginationAndCriteria(
      1,
      newCriteriaFromLookupHandler,
      "",
    );
    this.state.value = "";
    // e.preventDefault();
    setTimeout(() => {
      this.setFocusOnResultGrid();
    }, 500);
  };

  conditionalRowStyles = [
    {
      when: (row) => this.checkCurrentRow(row),
      style: {
        // backgroundColor: "rgba(140, 140, 140, 0.9)",
        backgroundColor: "#ddd",
        // color: "white",
        // "&:hover": {
        //   // cursor: "pointer",
        // },
      },
    },
  ];

  checkCurrentRow = (row) => {
    let dataList = this.state.lookupdata;
    if (dataList) {
      let currentRow = dataList[this.state.currentRowIndex];
      if (currentRow) {
        return currentRow[this.valueColumnName] == row[this.valueColumnName];
      }
    }
    return false;
  };

  /*
Key	Code
ener key  13
left arrow	37
up arrow	38
right arrow	39
down arrow	40
*/

  resultGridHandleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      let dataList = this.state.lookupdata;
      if (dataList) {
        let currentRow = dataList[this.state.currentRowIndex];
        if (currentRow) {
          let selectedValue = currentRow[this.valueColumnName];
          this.props.onLookupValueSelected(selectedValue);
        }
      }
      event.preventDefault();
    } else if (event.keyCode == KeyConstants.UP_ARROW_KEY) {
      let currentRowIndex = this.state.currentRowIndex - 1;
      let dataList = this.state.lookupdata;
      if (dataList) {
        if (currentRowIndex < 0) {
          currentRowIndex = dataList.length - 1;
          if (currentRowIndex < 0) currentRowIndex = 0;
        }
      } else {
        currentRowIndex = 0;
      }
      this.setState({ currentRowIndex: currentRowIndex });
      this.scrollToRow(currentRowIndex);
      event.preventDefault();
    } else if (event.keyCode == KeyConstants.DOWN_ARROW_KEY) {
      let currentRowIndex = this.state.currentRowIndex + 1;
      let dataList = this.state.lookupdata;
      if (dataList) {
        if (currentRowIndex >= dataList.length) {
          currentRowIndex = 0;
        }
      } else {
        currentRowIndex = 0;
      }
      this.setState({ currentRowIndex: currentRowIndex });
      this.scrollToRow(currentRowIndex);
      event.preventDefault();
    }
  };

  onRowClicked = (row, event) => {
    let currentRowIndex = this.state.currentRowIndex;
    let dataList = this.state.lookupdata;
    if (dataList) {
      currentRowIndex = this.getRowIndex(dataList, row);
      if (currentRowIndex < 0) {
        currentRowIndex = 0;
      }
    }
    this.setState({ currentRowIndex: currentRowIndex });
    event.preventDefault();
  };

  onRowDoubleClicked = (row, event) => {
    let selectedValue = row[this.valueColumnName];
    if (selectedValue) {
      this.props.onLookupValueSelected(selectedValue);
    }
    event.preventDefault();
  };

  getRowIndex = (dataList, row) => {
    for (let i = 0; i < dataList.length; i++) {
      if (dataList[i][this.valueColumnName] === row[this.valueColumnName]) {
        return i;
      }
    }
    return -1;
  };

  scrollToRow = (currentRowIndex) => {
    let rowId = "row-" + currentRowIndex;
    scrollToElement(rowId);
  };

  searchBarKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ENTER_KEY) {
      this.filterList(1);
      e.preventDefault();
    }
  };

  onKeyDown = (e) => {
    if (e.keyCode === KeyConstants.ESCAPE_KEY) {
      this.closeLookup();
    }
  };
  render() {
    if (!!this.state.lookupHandler) {
    }
    const CriteriaView = this.props.lookupHandler.lookupCriteriaView;
    let lookupColumnsList = this.generateLookupColumns();
    let dataList = this.state.lookupdata;
    let totalCount = this.state.pageResultDetails.totalRecordsCount;
    let currentPageNumber = this.state.pageResultDetails.currentPageNumber;
    let resultPageSize = this.state.pageResultDetails.pageSize;

    let totalPages = 0;
    let pageSize = resultPageSize;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    const isGenericLookup = this.state.isGenericLookup;
    return (
      <div onKeyDown={this.onKeyDown}>
        <MultiViewPopup
          // className="test-class-overlay"
          isLookup={true}
          // ref={this.skyLightDialogRef}
          // parentRef={this.skyLightDialogRef}
          isShowPopup={this.state.isShowResultLookup}
          title={
            !!this.props.lookupHandler
              ? this.props.lookupHandler.lookupTitle
              : ""
          }
          closeAlertModalCallBack={this.closeLookup}
          headercontent={
            this.state.showDataTable && (
              <div className="header-cnt-cntr">
                {/* below line is the criteria box old */}
                {/* <div className="criteria-box">{this.renderCriteria()}</div> */}
                <Form>
                  <Row>
                    <Col md={1}>
                      <FormLabel>Search</FormLabel>{" "}
                    </Col>
                    <Col md={7}>
                      <InputTextbox
                        id="search"
                        type="text"
                        placeholder="Search"
                        name="filterText"
                        value={this.state.filterText}
                        onChange={this.executeFilter}
                        onKeyDown={this.searchBarKeyDown}
                      />
                    </Col>
                    <div className="header-cnt-btns">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={() => this.filterList(1)}
                      >
                        {" "}
                        <FilterIcon />
                      </Button>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetFilter(e)}
                      >
                        {" "}
                        Reset
                      </Button>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetCriteria(e)}
                      >
                        {" "}
                        <RefreshIcon />
                      </Button>
                    </div>
                  </Row>
                </Form>
              </div>
            )
          }
          paginationContent={
            !isGenericLookup && (
              <div className="module_header_secondary_buttons">
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={() => this.loadFirst()}
                >
                  First
                </Button>
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={() => this.loadPrevious()}
                >
                  Previous
                </Button>
                <span className="black-color-font">
                  PAGE - {currentPageNumber} of {parseInt(totalPages)}
                </span>
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={() => this.loadNext()}
                >
                  Next
                </Button>
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={() => this.loadLast()}
                >
                  Last
                </Button>
              </div>
            )
          }
          resultContent={
            !!dataList &&
            this.state.showDataTable && (
              <div
                ref={this.resultGridRef}
                onKeyDown={this.resultGridHandleKeyDown}
                tabIndex="0"
                className="result-cnt"
              >
                <DataTable
                  keys="user"
                  columns={lookupColumnsList}
                  striped={true}
                  highlightOnHover={false}
                  pointerOnHover={false}
                  customStyles={this.customStyles}
                  data={dataList}
                  onRowClicked={this.onRowClicked}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  persistTableHead
                  fixedHeader
                  conditionalRowStyles={this.conditionalRowStyles}
                  // pagination
                  // selectableRows
                  // onSelectedRowsChange={this.onSelectedRowsChange}
                  pagination={isGenericLookup}
                  // expandableRows
                  // expander={this.ExpandedComponent}
                  // expandableRowsComponent={this.ExpandedComponent}
                  paginationPerPage={20}
                  paginationRowsPerPageOptions={[20, 40, 60, 80, 100]}
                />
              </div>
            )
          }
        />
        <MultiViewPopup
          popupLvlClass={"search-criteria-popup"}
          isModulePopup={false}
          isShowPopup={this.state.isShowLookup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeLookup}
          title={"SearchCriteria"}
          closeOnDocumentClick={false}
          // ref={this.criteriaViewRef}
          content={
            <div className="content">
              {/* {this.renderCriteria()} */}
              {!isEmpty(CriteriaView) ? (
                <CriteriaView
                  ref={this.criteriaViewRef}
                  searchCriteria={this.state.searchCriteria}
                  searchCriteriaCallBack={this.searchCriteriaCallBack}
                />
              ) : (
                <></>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

export const DatePickerComponent = (props) => {
  const dateComponentInput = useRef(null);
  const [dateId, setDateId] = useState(null);
  const [isCalendarOpen, setCalendarOpen] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const onSetDate = (value) => {
    if (value != null && value != undefined && value != "Invalid Date") {
      let date = new Date(value);
      if (date.toLocaleString() == "Invalid Date") {
        date = "";
      }
      return date;
    } else return null;
  };

  useEffect(() => {
    if (props.isModifyView != null && props.isModifyView != undefined) {
      if (props.isModifyView === true) {
        setDisabled(false);
      } else if (props.isModifyView === false) {
        if (!props.disabled) {
          setDisabled(false);
        } else if (props.disabled) {
          setDisabled(true);
        }
      }
    } else {
      setDisabled(props.disabled);
    }
  });

  const onDateChange = (date) => {
    if (date != null && date != undefined && date != "Invalid Date") {
      const localOffset = date.getTimezoneOffset(); // Get the local time zone offset in minutes
      date.setMinutes(date.getMinutes() - localOffset); // Adjust the date for local time zone
      //let formattedDate = date.toJSON();
      let formattedDate = date.toISOString().slice(0, 10);
      let tempEventObejct = customEventObject(props.name, formattedDate);
      props.onChange(tempEventObejct);
    } else {
      if (document.activeElement.id) {
        let id = document.activeElement.id;
        document.getElementById(id).focus();
      }
    }

    if (isCalendarOpen) {
      setCalendarOpen(false);
    }
  };

  const handleFocus = (event) => {
    setDateId(document.activeElement.id);
    event.target.select();
  };

  const onCalendarClose = (event) => {
    if (dateId != null && dateId != undefined && dateId != "Invalid Date") {
      let id = document.getElementById(dateId);
      if (id != null && id != undefined && id != "Invalid Date") {
        document.getElementById(dateId).focus();
        focusNextElement();
      }
    }
  };

  const onCalendarOpen = (event) => {
    setDateId(document.activeElement.id);
  };

  const handleOnBlur = (event) => {
    let dateString = event.target.value;
    handleDateBeforeOnChange(dateString);
    setCalendarOpen(false);
  };

  const handleDateBeforeOnChange = (date) => {
    let finalDate = "";
    //finalDate=date;
    finalDate = moment(date, "MM.DD.YYYY").toDate();
    onDateChange(finalDate);
    setCalendarOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.TAB_KEY) {
      focusNextElement();
    }
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      focusNextElement();
    }

    //for f2 to show the calendar
    if (event.keyCode == KeyConstants.F2_KEY) {
      setCalendarOpen(true);
    }

    // press esc for calendar close
    if (event.keyCode == KeyConstants.ESCAPE_KEY) {
      setCalendarOpen(false);
    }
  };

  const calendarIconClick = (e) => {
    let currentValue = document.getElementById(props.name);
    setDateId(currentValue.id);
    document.getElementById(currentValue.id).focus();
    setCalendarOpen(true);
  };
  let isMandatory = false;
  let classNames = "form-control";
  if (props.isMandatory != null && props.isMandatory != undefined)
    isMandatory = props.isMandatory;
  let style = {};
  if (isMandatory) {
    style = {
      // backgroundColor: "#E3F2C1",
      // backgroundColor: "#d8f8dd",
      backgroundColor: "#E3F2C1",
    };
    classNames = "form-control isMandatory";
  } else {
    classNames = "form-control";
  }

  return (
    <div className="inner-addon right-addon">
      {!isDisabled && (
        <i className="glyphicon" onClick={calendarIconClick}>
          <CalendarIcon />
        </i>
      )}
      <DatePicker
        id={props.name}
        ref={dateComponentInput}
        onChange={(date) => onDateChange(date)}
        selected={onSetDate(props.value)}
        className={classNames}
        type="date"
        dateFormat="MM/dd/yyyy"
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        onCalendarClose={onCalendarClose}
        onCalendarOpen={onCalendarOpen}
        disabled={isDisabled}
        open={isCalendarOpen}
        onBlur={handleOnBlur}
        popperPlacement="auto"
        shouldCloseOnSelect={true}
        // style={style}
      />
    </div>
  );
};

export const DatePickerComponent_adv = (props) => {
  const [dateId, setDateId] = useState(null);
  const [isCalendarOpen, setCalendarOpen] = useState(false);
  const [isDisabled, setDisabled] = useState(false);

    // NEW: ref around the wrapper div, used to detect outside clicks
  const wrapperRef = useRef(null);
  const onSetDate = (value) => {
    // console.log("onSetDate",value)
    if (value != null && value != undefined && value != "Invalid Date") {
      let date = new Date(value);
      if (date.toLocaleString() == "Invalid Date") {
        date = "";
      }
      //console.log("ONSetDate : ", date);
      // return moment.utc(date).local().toDate();
      return date;
    } else return null;
  };

  useEffect(() => {
    if (props.isModifyView != null && props.isModifyView != undefined) {
      if (props.isModifyView === true) {
        setDisabled(false);
      } else if (props.isModifyView === false) {
        if (!props.disabled) {
          setDisabled(false);
        } else if (props.disabled) {
          setDisabled(true);
        }
      }
    } else {
      setDisabled(props.disabled);
    }
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideWrapper =
        wrapperRef.current && wrapperRef.current.contains(event.target);
      const clickedInsidePopper =
        event.target.closest &&
        event.target.closest(".react-datepicker-popper");

      if (!clickedInsideWrapper && !clickedInsidePopper) {
        setCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onDateChange = (date) => {
    // console.log("onDateChange",date)

    if (date != null && date != undefined && date != "Invalid Date") {
      //let formattedDate = date.toJSON();
      let formattedDate = date;
      

      let tempEventObejct = customEventObject(props.name, formattedDate);
      props.onChange(tempEventObejct);
    } else {
      if (document.activeElement.id) {
        let id = document.activeElement.id;
        document.getElementById(id).focus();
      }
    }

    if (isCalendarOpen) {
      setCalendarOpen(false);
    }
  };

  const handleRawChange = (e) => {
    const value = e.target.value;

    // Try to parse pasted value
    const parsedDate = new Date(value);

    if (!isNaN(parsedDate)) {
      let tempEventObejct = customEventObject(props.name, parsedDate);
      props.onChange(tempEventObejct);
    }
  };

  // For Testing Purpose

  // const onDateChange = (date) => {
  //   console.log("onDateChange",date)
  //   if (date != null && date != undefined && date != "Invalid Date") {
  //     // const localOffset = date.getTimezoneOffset(); // Get the local time zone offset in minutes
  //     // date.setMinutes(date.getMinutes() - localOffset); // Adjust the date for local time zone
  //    // let formattedDate = date.toISOString();
  //    const locale = process.env.REACT_APP_DATE_LOCALE;
  //    console.log("locale",locale)
  //    const timeZone = process.env.REACT_APP_TIME_FORMAT;
  //    console.log("timeZone",timeZone)
  //   //  let formattedDate = date.toJSON();
  //   const tempDate = new Intl.DateTimeFormat(locale, {
  //     timeZone,
  //    // dateStyle: 'short' // MM/DD/YYYY format for en-US
  //    year: 'numeric',
  //    month: '2-digit',
  //    day: '2-digit'
  //   }).format(date);
  //     console.log("formattedDate",tempDate)
  //     const [month, day, year] = tempDate.split('/');
  //     const isoDate = `${year}-${month}-${day}`;
  //     const formattedDate = isoDate;
  //     console.log("formattedDate",formattedDate)
  //     let tempEventObejct = customEventObject(props.name, formattedDate);
  //     props.onChange(tempEventObejct);
  //   } else {
  //     if (document.activeElement.id) {
  //       let id = document.activeElement.id;
  //       document.getElementById(id).focus();
  //     }
  //   }

  //   if (isCalendarOpen) {
  //     setCalendarOpen(false);
  //   }
  // };

  const handleFocus = (event) => {
    setDateId(document.activeElement.id);
    event.target.select();
  };

  const onCalendarClose = (event) => {
    if (dateId != null && dateId != undefined && dateId != "Invalid Date") {
      let id = document.getElementById(dateId);
      if (id != null && id != undefined && id != "Invalid Date") {
        document.getElementById(dateId).focus();
        focusNextElement();
      }
    }
  };

  const onCalendarOpen = (event) => {
    setDateId(document.activeElement.id);
  };

  const handleOnBlur = (event) => {
    let dateString = event.target.value;
    //  console.log("dateString",dateString)
    handleDateBeforeOnChange(dateString);
    setCalendarOpen(false);
  };

  const handleDateBeforeOnChange = (date) => {
    let finalDate = "";
    finalDate = date;

    //finalDate = moment(date, "MM.DD.YYYY").toDate();
    // console.log("finalDate",finalDate)
    onDateChange(finalDate);
    setCalendarOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.TAB_KEY) {
      focusNextElement();
    }
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      focusNextElement();
    }

    //for f2 to show the calendar
    if (event.keyCode == KeyConstants.F2_KEY) {
      setCalendarOpen(true);
    }

    // press esc for calendar close
    if (event.keyCode == KeyConstants.ESCAPE_KEY) {
      setCalendarOpen(false);
    }
  };

  const calendarIconClick = (e) => {
    let currentValue = document.getElementById(props.name);
    setDateId(currentValue.id);
    document.getElementById(currentValue.id).focus();
    // setCalendarOpen(true);
     setCalendarOpen((prevOpen) => !prevOpen);
  };
  let isMandatory = false;
  let classNames = "form-control";
  if (props.isMandatory != null && props.isMandatory != undefined)
    isMandatory = props.isMandatory;
  let style = {};
  if (isMandatory) {
    style = {
      // backgroundColor: "#E3F2C1",
      // backgroundColor: "#d8f8dd",
      backgroundColor: "#E3F2C1",
    };
    classNames = "form-control isMandatory";
  } else {
    classNames = "form-control";
  }

  return (
    <div className="inner-addon right-addon"  ref={wrapperRef}>
      {!isDisabled && (
        <i className="glyphicon" onClick={calendarIconClick}>
          <CalendarIcon />
        </i>
      )}
      <DatePicker
        id={props.name}
        // ref={dateComponentInput}
        onChange={(date) => onDateChange(date)}
        onChangeRaw={handleRawChange}
        selected={onSetDate(props.value)}
        className={classNames}
        type="date"
        dateFormat="MM/dd/yyyy"
        // dateFormat="yyyy-MM-dd"
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        onCalendarClose={onCalendarClose}
        onCalendarOpen={onCalendarOpen}
        disabled={isDisabled}
        open={isCalendarOpen}
        // onBlur={handleOnBlur}
        popperPlacement="auto"
        shouldCloseOnSelect={true}
        // style={style}
      />
    </div>
  );
};

export const MessageBoxComponent = (props) => {
  const handleAfterClose = () => {
    props.closeMessageModelCallBack();
  };
  const onYesButtonClick = (e) => {
    if (e.detail == 1) props.onYesButtonClick();
  };
  const onNoButtonClick = (e) => {
    if (e.detail == 1) props.onNoButtonClick();
  };
  const onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ESCAPE_KEY) {
      props.closeMessageModelCallBack();
    }
  };
  return (
    <div onKeyDown={onKeyDown}>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel8"}
        isModulePopup={false}
        closeOnEsc={true}
        isShowPopup={props.isShowPopup}
        title={props.title}
        closeAlertModalCallBack={handleAfterClose}
        content={
          <div className="d-flex justify-content-center h-auto">
            <div className="h-auto">
              <Row>
                <div className="warningMsg">{props.warningMesage}</div>
              </Row>
              <div className="d-flex justify-content-center">
                <Button
                  size="sm"
                  onClick={(e) => onYesButtonClick(e)}
                  id="fabric_Add_Button"
                  className="text-center"
                >
                  Yes
                </Button>
                <Button
                  size="sm"
                  onClick={(e) => onNoButtonClick(e)}
                  id="fabric_Add_Button"
                  className="text-center"
                >
                  No
                </Button>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export class NumberFormatInputbox extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.state = { textValue: this.props.value };
  }

  componentDidMount() {
    this.modifyTextBox();
  }

  modifyTextBox = () => {
    if (this.props.isModifyView != null) {
      if (this.props.isModifyView) {
        if (this.props.isModifyEditable != null) {
          if (this.props.isModifyEditable) {
            this.setState({
              //isReadOnly: !this.props.isModifyView,
              isDisabled: !this.props.isModifyEditable,
            });
          } else {
            this.setState({
              //isReadOnly: !this.props.isModifyView,
              isDisabled: this.props.isModifyEditable,
            });
          }
        } else {
          this.setState({
            //isReadOnly: !this.props.isModifyView,
            isDisabled: !this.props.isModifyView,
          });
        }
      } else if (this.props.isModifyEditable != null) {
        this.setState({
          //isReadOnly: !this.props.isModifyView,
          isDisabled: this.props.isModifyEditable,
        });
      }
    }
  };

  componentDidUpdate() {}
  focus = () => {
    this.componentRef.current.focus();
  };
  handleFocus = (event) => {
    event.target.select();
  };

  handleKeyDown = (event) => {
    let isCustomHandledKeyDown = this.props.isCustomHandledKeyDown;
    if (isCustomHandledKeyDown) {
      this.props.customeOnKeyDown(event);
    } else {
      if (event.keyCode == KeyConstants.ENTER_KEY) {
        focusNextElement();
      }
    }
  };

  onNumberChange = (e, fieldName) => {
    if (e.value == "") {
      //e.value = 0.0;
    }
    let tempEventObejct = customEventObject(fieldName, e.value);
    if (this.props.onChange) this.props.onChange(tempEventObejct);
  };

  handleOnBlur = (event) => {
    if (this.props.onBlur != null && this.props.onBlur != undefined) {
      this.props.onBlur(event);
    }
  };

  render() {
    let disabled = false;
    if (this.state.isDisabled !== true) {
      if (this.props.disabled == "" || this.props.disabled == null) {
        disabled = this.props.readOnly;
      } else {
        disabled = this.props.disabled;
      }
    } else {
      disabled = this.state.isDisabled;
    }
    let isMandatory = false;
    if (this.props.isMandatory != null && this.props.isMandatory != undefined)
      isMandatory = this.props.isMandatory;
    let style = {};
    if (isMandatory) {
      style = {
        backgroundColor: "#E3F2C1",
        textAlign: "end",
      };
    } else {
      style = {
        textAlign: "end",
      };
    }
    return (
      <div>
        <NumericFormat
          ref={this.componentRef}
          id="id1"
          key="key1"
          value={this.props.value}
          thousandSeparator=","
          customInput={FormControl}
          // thousandSeparator={true}
          fixedDecimalScale={true}
          decimalScale={this.props.decimalScale}
          name={this.props.name}
          className={this.props.className}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onValueChange={(e) => this.onNumberChange(e, this.props.name)}
          disabled={disabled}
          onBlur={this.handleOnBlur}
          autoComplete="off"
          style={style}
        />
      </div>
    );
  }
}

export class EditableDataGrid extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  toDataGridColumn = (columnDef) => {
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let isCenter = columnDef.columnAlignment == 2 ? true : false;
    let tableHeaderAlign = "left";
    if (isRight) tableHeaderAlign = "right";
    else if (isCenter) tableHeaderAlign = "center";
    let tempDataGridColumnDef = {
      name: columnDef.columnDisplayName,
      //selector: columnDef.columnBindingPropertyName,
      selector: (row) => row[columnDef.columnBindingPropertyName],
      sortable: true,
      right: isRight,
      minWidth: columnDef.columnMinWidth,
      maxWidth: columnDef.columnMaxWidth,
      center: isCenter,
      wrap: true,
      tableHeaderAlign: tableHeaderAlign,
      style: columnDef.columnStyle,
      // conditionalCellStyles?: IDataTableConditionalCellStyles<T>[];
    };

    if (columnDef.buttonColumn === true) {
      // if (columnDef.sortable === true) {
      let cellDef = (row) => (
        <Button
          data-tag="allowRowEvents"
          onClick={(evt) => this.onButtonClick(evt, columnDef, row)}
          hidden={columnDef.columnDisabled}
        >
          {columnDef.columnBindingPropertyName}
        </Button>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
      /* } else {
        <FormLabel
          //data-tag="allowRowEvents"
          onClick={(evt) => this.onButtonClick(evt, columnDef)}
          // hidden={columnDef.columnDisabled}
        ></FormLabel>;
        // {columnDef.columnDisplayName}

        //  let cellDef = (row) => (
        /*  <Button
            //data-tag="allowRowEvents"
            onClick={(evt) => this.onButtonClick(evt, columnDef)}
           // hidden={columnDef.columnDisabled}
          >
           // {columnDef.columnDisplayName}
          </Button>
        //);
       // tempDataGridColumnDef.columnheader = cellDef;
        tempDataGridColumnDef.ignoreRowClick = true;

        return tempDataGridColumnDef;
      }*/
    }
    if (columnDef.inputBoxColumn === true) {
      let targetInputBoxName = columnDef.inputBoxTargetColumnName;

      let cellDef = (row) => (
        <NumberFormatInputbox
          name={targetInputBoxName}
          onChange={(e) => this.onInputBoxChange(e, columnDef, row)}
          onBlur={(evt) => this.onBlur(evt, columnDef, row)}
          className="text-right col-sm-12"
          value={row[columnDef.columnBindingPropertyName]}
          decimalScale={2}
          disabled={columnDef.columnDisabled}
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }
    if (columnDef.imageColumn === true) {
      let cellDef = (row) => (
        <img
          src={this.onImageLinkCallBack(columnDef, row)}
          width={50}
          height={30}
          mode="fit"
        />
      );

      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }

    if (columnDef.hyperLinkcolumn === true) {
      let cellDef = (row) => (
        <span
          className="dataGridHyperLink"
          data-tag="allowRowEvents"
          onClick={(evt) => this.onHyperLinkClick(evt, columnDef, row)}
        >
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
    }

    if (columnDef.checkBoxColumn === true) {
      let cellDef = (row) => (
        <InputCheckbox
          name={columnDef.columnBindingPropertyName}
          data-tag="allowRowEvents"
          onChange={(evt) => this.onCellCheckBoxClick(evt, columnDef, row)}
          checked={row[columnDef.columnBindingPropertyName]}
          disabled={columnDef.columnDisabled}
          disableLabel={true}
        ></InputCheckbox>
      );

      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
    }

    if (columnDef.statusColumn === true) {
      let cellDef = (row) => (
        <span>
          {this.getStatusCaption(
            columnDef,
            row[columnDef.columnBindingPropertyName],
          )}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }
    if (columnDef.graphColumn === true) {
      let cellDef = (row) => (
        <div className="graph-wrap">
          {columnDef.graphValueProvider(columnDef, row)}
        </div>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }
    return tempDataGridColumnDef;
  };

  getStatusCaption = (columnDef, status) => {
    if (!!columnDef.getStatusCaption) {
      let finalStatus = columnDef.getStatusCaption(status);
      return finalStatus;
    }
  };

  onInputBoxChange = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.inputChangeCallback) {
        columnDef.inputChangeCallback(e, rowData);
      }
    }
  };

  onBlur = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.inputBoxOnBlurCallback) {
        columnDef.inputBoxOnBlurCallback(e, rowData);
      }
    }
  };

  onHyperLinkClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      let selectedValue = e.target.innerText;
      if (!!columnDef.hyperLinkCallback) {
        columnDef.hyperLinkCallback(selectedValue, rowData);
      }
    }
  };

  onImageLinkCallBack = (columnDef, rowData) => {
    if (!!columnDef.imageLinkCallBack) {
      let col = columnDef.imageLinkCallBack(columnDef, rowData);
      return col;
    }
  };

  onButtonClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.buttonClickCallback) {
        columnDef.buttonClickCallback(e, rowData);
      }
    }
  };

  onRowClicked = (e) => {};

  onCheckBoxClick = (e, columnDef, rowData) => {
    this.props.onCheckBoxClick(e);
  };

  onCellCheckBoxClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.checkBoxClickCallback) {
        rowData[columnDef.columnBindingPropertyName] = e.target.value;
        columnDef.checkBoxClickCallback(e, rowData);
      }
    }
  };
  customStyles = {
    table: {
      style: {
        height: "400px",
        width: "100%",
        ScrollX: false,
        overflow: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "80%",
        borderCollapse: "collapse",
        verticalAlign: "middle !important",
        padding: "1rem",
      },
    },
    header: {
      style: {
        display: "none",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        paddingTop: "5px",
        paddingBottom: "5px",
        // "&:not(:last-of-type)": {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#fff",
        // },
      },
    },
    // cells: {
    //   style: {
    //     // paddingTop: "5px",
    //     // paddingBottom: "5px",
    //     padding: "5px",
    //     borderRight: "2px solid #fff",
    //   },
    // },
    rows: {
      style: {
        minHeight: "20px",
      },
      denseStyle: {
        minHeight: "0px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#ddd",
        color: "#000",
      },
      stripedStyle: {
        color: "#000",
        backgroundColor: "#e9ecef",
      },
    },
    button: {
      default: "#5482AE",
    },
    headRow: {
      style: {
        backgroundColor: "#655f80",
        // paddingTop: "2px",
        // paddingBottom: "2px",
        minHeight: "2rem",
        // borderBottomWidth: "1px",
        // borderBottomColor: "#fff",
        // borderBottomStyle: "2px solid #fff",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        paddingRight: "5px",
        paddingLeft: "5px",
        borderRight: "2px solid #fff",
        textAlign: "center",
      },
      activeSortStyle: {
        color: "#fff",
        "&:focus": {
          outline: "none",
        },
        "&:hover:not(:focus)": {
          color: "#fff",
        },
        textAlign: "center",
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: "#fff",
        },
        "&:hover": {
          color: "#fff",
        },
        textAlign: "center",
      },
    },
  };
  render() {
    let dataGridColumnList = [];
    if (this.props.columnsList) {
      this.props.columnsList.map((cdef) =>
        dataGridColumnList.push(this.toDataGridColumn(cdef)),
      );
    }

    let noDataComponent = (
      <DataTableNoDataComponent isLoading={this.props.isLoading} />
    );

    return (
      <DataTable
        ref={this.componentRef}
        customStyles={this.customStyles}
        keys={this.props.keys}
        columns={dataGridColumnList}
        striped={true}
        highlightOnHover={true}
        data={this.props.dataList}
        noDataComponent={noDataComponent}
        onRowClicked={this.onRowClicked}
        persistTableHead
        selectableRows={this.props.selectableRows} // add for checkbox selection
        onSelectedRowsChange={this.onCheckBoxClick}
        selectableRowSelected={this.props.selectableRowSelected}
        disabled={this.props.disabled}
        // customStyles={this.props.customStyles}
        fixedHeader={this.props.fixedHeader}
      />
    );
  }
}

export class DataGridComponentColumnDefinitions {
  constructor() {
    this.columnDisplayName = "";
    this.columnBindingPropertyName = "";
    this.columnAlignment = 0; // 0 -->Left  1-->Right  2-->Center
    this.columnComponentType = "";
    this.columnOnChangeLink = null;
    this.columnOnClickLink = null;
    this.columnOnKeyDownLink = null;
    this.columnOnBlurLink = null;
    this.columnCheckBoxClickLink = null;
    this.columnRowClickLink = null;
    this.columnImageClickLink = null;
    this.columnMinWidth = "";
    this.columnMaxWidth = "";
    this.columnDisabled = false;

    this.columnAutoCompleteLookUpValues = new Array();
    this.columnAutoCompleteDefaultValue = "";
    this.columnAutoCompleteValueProperty = "";
    this.columnAutoCompleteDescriptionProperty = "";
    this.columnAutoCompleteDynamicSearchLink = "";

    this.customColumnValueLink = "";
  }
  setDetails = (
    columnDisplayName = "",
    columnBindingPropertyName = "",
    columnAlignment = 0,
  ) => {
    this.columnDisplayName = columnDisplayName;
    this.columnBindingPropertyName = columnBindingPropertyName;
    this.columnAlignment = columnAlignment;
    return this;
  };
  setColumnMinWidth = (columnMinWidth = "") => {
    this.columnMinWidth = columnMinWidth;
    return this;
  };
  setColumnMaxWidth = (columnMaxWidth = "") => {
    this.columnMaxWidth = columnMaxWidth;
    return this;
  };
  setComponentType = (columnComponentType = "") => {
    this.columnComponentType = columnComponentType;
    return this;
  }; //Type = "null",Type = "button",Type = "image",Type = "date",Type = "number"
  setDisabled = (columnDisabled = false) => {
    this.columnDisabled = columnDisabled;
    return this;
  };
  setOnClickLink = (columnOnClickLink = null) => {
    this.columnOnClickLink = columnOnClickLink;
    return this;
  };
  setOnChangeLink = (columnOnChangeLink = null) => {
    this.columnOnChangeLink = columnOnChangeLink;
    return this;
  };
  setOnKeyDownLink = (columnOnKeyDownLink = null) => {
    this.columnOnKeyDownLink = columnOnKeyDownLink;
    return this;
  };
  setOnBlurLink = (columnOnBlurLink = null) => {
    this.columnOnBlurLink = columnOnBlurLink;
    return this;
  };
  setOnKeyDownLink = (columnOnKeyDownLink = null) => {
    this.columnOnKeyDownLink = columnOnKeyDownLink;
    return this;
  };
  setOnCheckBoxClickLink = (columnCheckBoxClickLink = null) => {
    this.columnCheckBoxClickLink = columnCheckBoxClickLink;
    return this;
  };
  setOnRowClickLink = (columnRowClickLink = null) => {
    this.columnRowClickLink = columnRowClickLink;
    return this;
  };
  setOnImageClickLink = (columnImageClickLink = null) => {
    this.columnImageClickLink = columnImageClickLink;
    return this;
  };
  setAutoCompleteTextBoxDetails = (
    columnAutoCompleteLookUpValues = new Array(),
    columnAutoCompleteValueProperty = "",
    columnAutoCompleteDescriptionProperty = "",
  ) => {
    this.columnAutoCompleteLookUpValues = columnAutoCompleteLookUpValues;
    this.columnAutoCompleteValueProperty = columnAutoCompleteValueProperty;
    this.columnAutoCompleteDescriptionProperty =
      columnAutoCompleteDescriptionProperty;
    return this;
  };
  setAutoCompleteDynamicSearchLink = (
    columnAutoCompleteDynamicSearchLink = null,
  ) => {
    this.columnAutoCompleteDynamicSearchLink =
      columnAutoCompleteDynamicSearchLink;
    return this;
  };
  setCustomColumnValueLink = (customColumnValueLink = null) => {
    this.customColumnValueLink = customColumnValueLink;
    return this;
  };
}
export class DataGridComponent extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }
  toDataGridColumn = (columnDef) => {
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let isCenter = columnDef.columnAlignment == 2 ? true : false;
    let tempDataGridColumnDef = {
      name: columnDef.columnDisplayName,
      selector: columnDef.columnBindingPropertyName,
      sortable: true,
      right: isRight,
      center: isCenter,
      minWidth: columnDef.columnMinWidth,
      maxWidth: columnDef.columnMaxWidth,
      wrap: true,
    };
    if (!!columnDef.columnOnClickLink) {
      let cellDef = (row) => (
        <span
          className="dataGridHyperLink"
          data-tag="allowRowEvents"
          onClick={(evt) => this.onClick(evt, columnDef, row)}
        >
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }

    if (columnDef.columnComponentType === "button") {
      let cellDef = (row) => (
        <Button
          data-tag="allowRowEvents"
          onClick={(evt) => this.onClick(evt, columnDef, row)}
        >
          {columnDef.columnBindingPropertyName}
        </Button>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
      return tempDataGridColumnDef;
    }
    if (columnDef.columnComponentType === "number") {
      let columnBindingPropertyName = columnDef.columnBindingPropertyName;
      let cellDef = (row) => (
        <NumberFormatInputbox
          name={columnBindingPropertyName}
          onChange={(evt) => this.onChange(evt, columnDef, row)}
          onClick={(evt) => this.onClick(evt, columnDef, row)}
          onKeyDown={(evt) => this.onKeyDown(evt, columnDef, row)}
          onBlur={(evt) => this.onBlur(evt, columnDef, row)}
          className="text-right col-sm-12"
          value={row[columnDef.columnBindingPropertyName]}
          decimalScale={2}
          disabled={columnDef.disableTargetColumn}
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }
    if (columnDef.imageColumn === "image") {
      let cellDef = (row) => (
        <img
          src={this.onImageClickLink(columnDef, row)}
          width={50}
          height={30}
          mode="fit"
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
      return tempDataGridColumnDef;
    }
    if (columnDef.columnComponentType === "autocomplete") {
      let columnBindingPropertyName = columnDef.columnBindingPropertyName;
      let cellDef = (row) => (
        // <NumberFormatInputbox
        //   name={columnBindingPropertyName}
        //   onChange={(evt) => this.onChange(evt, columnDef, row)}
        //   className="text-right col-sm-12"
        //   value={row[columnDef.columnBindingPropertyName]}
        //   decimalScale={2}
        //   disabled={columnDef.disableTargetColumn}
        // />
        <AutoCompleteTextbox
          name={columnBindingPropertyName}
          placeholder={"Enter " + columnBindingPropertyName}
          onChange={(evt) => this.onChange(evt, columnDef, row)}
          readOnly={columnDef.disableTargetColumn}
          defaultValue={row[columnDef.columnBindingPropertyName]}
          lookupValues={columnDef.columnAutoCompleteLookUpValues}
          valuePropery={columnDef.columnAutoCompleteValueProperty}
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }

    if (columnDef.columnComponentType === "dynamicautocomplete") {
      let columnBindingPropertyName = columnDef.columnBindingPropertyName;
      let cellDef = (row) => (
        <DynamicAutoCompleteTextbox
          ref={this.customerCodeRef}
          name={columnBindingPropertyName}
          placeholder={"Select" + columnBindingPropertyName}
          onChange={(evt) => this.onChange(evt, columnDef, row)}
          readOnly={columnDef.disableTargetColumn}
          disabled={columnDef.columnDisabled}
          defaultValue={row[columnDef.columnBindingPropertyName]}
          lookupValues={columnDef.columnAutoCompleteLookUpValues}
          //isLoading={true}
          handleSearch={(searchString) =>
            this.onSearch(searchString, columnDef, row)
          }
          onFocus={(evt) => this.onFocus(evt, columnDef, row)}
          valuePropery={columnDef.columnAutoCompleteValueProperty}
          descriptionProperty={columnDef.columnAutoCompleteValueProperty}
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }
    return tempDataGridColumnDef;
  };

  // this.columnOnChangeLink = false;
  // this.columnOnClickLink = false;
  // this.columnOnKeyDownLink = false;
  // this.columnOnBlurLink = false;
  // this.columnCheckBoxLink = false;

  onFocus = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.columnOnChangeLink) {
        //columnDef.columnOnChangeLink(e, rowData);
      }
    }
  };
  onChange = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.columnOnChangeLink) {
        columnDef.columnOnChangeLink(e, rowData);
      }
    }
  };
  onClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      let selectedValue = e.target.innerText;
      if (!!columnDef.columnOnClickLink) {
        columnDef.columnOnClickLink(selectedValue, rowData);
      }
    }
  };
  onImageClickLink = (columnDef, rowData) => {
    if (!!columnDef.columnOnClickLink) {
      columnDef.columnImageClickLink(columnDef, rowData);
    }
  };
  onKeyDown = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.columnOnKeyDownLink) {
        let tempEventObejct = customEventObject(
          columnDef.columnBindingPropertyName,
          e,
        );
        columnDef.columnOnKeyDownLink(tempEventObejct, rowData);
      }
    }
  };
  onBlur = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.columnOnBlurLink) {
        columnDef.columnOnBlurLink(e, rowData);
      }
    }
  };
  onCheckBoxClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.columnCheckBoxLink) {
        columnDef.columnCheckBoxLink(e, rowData);
      }
    }
  };
  onSearch = (searchString, columnDef, rowData) => {
    if (searchString) {
      if (!!columnDef.columnAutoCompleteDynamicSearchLink) {
        columnDef.columnAutoCompleteDynamicSearchLink(
          searchString,
          columnDef,
          rowData,
        );
      }
    }
  };

  customStyles = {
    table: {
      style: {
        height: "400px",
        width: "100%",
        ScrollX: false,
        overflow: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "80%",
        borderCollapse: "collapse",
        verticalAlign: "middle !important",
      },
    },
    rows: {
      style: {
        minHeight: "20px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#ddd",
        color: "000",
      },
      stripedStyle: {
        color: "#000",
        backgroundColor: "#e9ecef",
      },
    },
    button: {
      default: "#5482AE",
    },
    headRow: {
      style: {
        textAlign: "center",
        backgroundColor: "#655f80",
        paddingTop: "2px",
        paddingBottom: "2px",
        minHeight: "2rem",
        borderBottomWidth: "1px",
        borderBottomColor: "#fff",
        borderBottomStyle: "2px solid #fff",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        paddingRight: "5px",
        paddingLeft: "5px",
      },
      activeSortStyle: {
        color: "#fff",
        "&:focus": {
          outline: "none",
        },
        "&:hover:not(:focus)": {
          color: "#fff",
        },
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: "#fff",
        },
        "&:hover": {
          color: "#fff",
        },
      },
    },
  };

  render() {
    let dataGridColumnList = [];
    if (this.props.columnsList) {
      this.props.columnsList.map((cdef) =>
        dataGridColumnList.push(this.toDataGridColumn(cdef)),
      );
    }
    let noDataComponent = (
      <DataTableNoDataComponent isLoading={this.props.isLoading} />
    );
    return (
      <DataTable
        ref={this.componentRef}
        keys={this.props.keys}
        columns={dataGridColumnList}
        striped={true}
        highlightOnHover={true}
        data={this.props.dataList}
        noDataComponent={noDataComponent}
        onRowClicked={this.props.onRowClicked}
        persistTableHead
        selectableRows={this.props.selectableRows} // add for checkbox selection
        onSelectedRowsChange={this.onCheckBoxClick}
        disabled={this.props.disabled}
        // customStyles={this.props.customStyles}
        customStyles={this.customStyles}
        fixedHeader={this.props.fixedHeader}
      />
    );
  }
}
export const Alert = (props) => {
  const handleClose = () => props.handleClose();
  return (
    <>
      <Modal show={props.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.error}</Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

const ShowError = (value) => {
  alert("Error : " + value);
};

const ShowInfo = (value) => {
  alert("Information : " + value);
};

export class InputRadiobox extends React.Component {
  constructor(props) {
    super(props);
    this.lookupRef = React.createRef();
    this.componentRef = React.createRef();
    this.state = { checked: this.props.checked };
  }

  componentDidUpdate() {
    if (this.props.checked !== this.state.checked)
      this.setState({ checked: this.props.checked });
  }

  handleFocus = (event) => {
    event.target.select();
  };

  handleKeyDown = (event) => {
    if (event.keyCode == KeyConstants.ENTER_KEY) {
      focusNextElement();
    }
  };

  handleOnChange = (event) => {
    let isChecked = event.target.checked;
    this.setState({ checked: isChecked });

    let tempEventObejct = customEventObject(this.props.name, isChecked);
    this.props.onChange(tempEventObejct);
  };

  render() {
    return (
      <div className="check-box-container">
        <input
          type="radio"
          {...this.props}
          checked={this.state.checked}
          onChange={this.handleOnChange}
        />
      </div>
    );
  }
}
export const AddressComponent = (props) => {
  const [addressData, setAddressData] = useState(props.addressData);
  const [alertMessage, setAlertMessage] = useState(new Array());
  const [alertType, setAlertType] = useState("");
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isFirst, setisFirst] = useState(true);
  const [cityLookupHandler, setCityLookupHandler] = useState(null);
  const [stateLookupHandler, setStateLookupHandler] = useState(null);
  const [countryLookupHandler, setCountryLookupHandler] = useState(null);
  useEffect(() => {
    if (isFirst) {
      initLookupHandlers();
    }
    setAddressData(props.addressData);
  });
  const initLookupHandlers = () => {
    const cityLookupHandler = new GenericAttributeLookupHandler(
      props.cityList,
      "City",
    );
    const stateLookupHandler = new GenericAttributeLookupHandler(
      props.stateList,
      "State",
    );
    const countryLookupHandler = new GenericAttributeLookupHandler(
      props.countryList,
      "Country",
    );
    if (!isEmptyArray(props.cityList)) {
      setCityLookupHandler(cityLookupHandler);
      setisFirst(false);
    }
    if (!isEmptyArray(props.stateList)) {
      setStateLookupHandler(stateLookupHandler);
      setisFirst(false);
    }
    if (!isEmptyArray(props.countryList)) {
      setCountryLookupHandler(countryLookupHandler);
      setisFirst(false);
    }
  };
  const onClick = (e) => {
    if (e.detail == 1) props.onClick();
  };
  const onChange = (e) => {
    props.onChange(e);
  };
  const handleAfterClose = () => {
    props.closeAlertAddressModalCallBack();
  };
  const hideAlertCallBack = (msgType, isDisplayed) => {
    setIsShowAlert(false);
  };

  const onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ESCAPE_KEY) {
      props.closeAlertAddressModalCallBack();
    }
  };

  return (
    <div onKeyDown={onKeyDown}>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel5"}
        isModulePopup={false}
        closeOnEsc={true}
        isShowPopup={props.isShowPopup}
        title={props.title}
        closeAlertModalCallBack={handleAfterClose}
        alertContainerBox={
          <AlertToolBox
            alertMsgList={alertMessage}
            alertErrorType={alertType}
            isShowAlert={isShowAlert}
            hideAlertCallBack={hideAlertCallBack}
          />
        }
        headerButtonContainer={
          <div className="floatLeft">
            <Button
              className="header_buttons enterFocus"
              size="sm"
              onClick={(e) => onClick(e)}
              disabled={props.disabled}
            >
              Update Address
            </Button>
          </div>
        }
        content={
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Address1</FormLabel>
              </Col>
              <Col sm="">
                <InputTextbox
                  name="address1"
                  type="text"
                  placeholder="Enter Address"
                  value={addressData.address1}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Address2</FormLabel>
              </Col>
              <Col sm="">
                <InputTextbox
                  name="address2"
                  type="text"
                  placeholder="Enter Address"
                  value={addressData.address2}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>City</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="city"
                  type="text"
                  placeholder="Enter city"
                  value={addressData.city}
                  onChange={props.onCityChange}
                  lookupRequired={true}
                  lookupHandler={cityLookupHandler}
                  enterKeyEventHandler={props.cityEnterKeyEventHandler}
                  autoCompleteListData={props.cityPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={props.displayAutoCompleteCityList}
                  showAutoCompleteList={props.showAutoCompleteCityList}
                  disabled={props.disabled}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Phone_1</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="phone1"
                  type="text"
                  placeholder="Enter Phone"
                  value={addressData.phone1}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Country</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="country"
                  type="text"
                  placeholder="Enter Country"
                  value={addressData.country}
                  onChange={props.onCountryChange}
                  lookupRequired={true}
                  lookupHandler={countryLookupHandler}
                  enterKeyEventHandler={props.countryEnterKeyEventHandler}
                  autoCompleteListData={
                    props.countryPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={props.displayAutoCompleteCountryList}
                  showAutoCompleteList={props.showAutoCompleteCountryList}
                  disabled={props.disabled}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Phone_2</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="phone2"
                  type="text"
                  placeholder="Enter Phone"
                  value={addressData.phone2}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>State</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="state"
                  type="text"
                  placeholder="Enter state"
                  value={addressData.state}
                  onChange={props.onStateChange}
                  lookupRequired={true}
                  lookupHandler={stateLookupHandler}
                  enterKeyEventHandler={props.stateEnterKeyEventHandler}
                  autoCompleteListData={props.statePageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={props.displayAutoCompleteStateList}
                  showAutoCompleteList={props.showAutoCompleteStateList}
                  disabled={props.disabled}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Mobile#</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="mobilePhone"
                  type="text"
                  placeholder="Enter MobilePhone"
                  value={addressData.mobilePhone}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Zip</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="zip"
                  type="text"
                  placeholder="Enter Zip"
                  value={addressData.zip}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Mail</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="ccEmail"
                  type="text"
                  placeholder="Enter Email"
                  value={addressData.ccEmail}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Website</FormLabel>
              </Col>
              <Col sm="5">
                <InputTextbox
                  name="website"
                  type="text"
                  placeholder="Enter Website"
                  value={addressData.website}
                  onChange={onChange}
                  disabled={props.disabled}
                />
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export const ReasonCaptureComponent = (props) => {
  const [reasonData, setReasonData] = useState(props.reasonData);
  const [reasonLookupHandler, setReasonLookupHandler] = useState(null);
  const [alertMessage, setAlertMessage] = useState(new Array());
  const [alertType, setAlertType] = useState("");
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isFirst, setisFirst] = useState(true);

  useEffect(() => {
    if (isFirst) {
      initLookupHandlers();
    }
  });

  const initLookupHandlers = () => {
    const reasonLookupHandler = new GenericAttributeLookupHandler(
      props.reasons,
      "reasons",
    );
    if (!isEmptyArray(props.reasons)) {
      setReasonLookupHandler(reasonLookupHandler);
      setisFirst(false);
    }
  };

  const handleAfterClose = () => {
    props.closeReasonModelCallBack();
    hideAlertCallBack();
  };

  const onChange = (e) => {
    props.onChange(e);
  };
  const onReasonDescChange = (e) => {
    props.onReasonDescChange(e);
  };

  const isValidReason = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(data)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(data.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      setAlertMessage(err_list);
      setAlertType("danger");
      setIsShowAlert(true);
    } else {
      isValid = true;
    }
    return isValid;
  };

  const onClick = (e) => {
    if (e.detail === 1) {
      let isValid = false;
      isValid = isValidReason(props.reasonData);
      if (isValid) {
        props.onClick();
      }
    }
  };

  const hideAlertCallBack = (msgType, isDisplayed) => {
    setIsShowAlert(false);
    setAlertMessage([]);
  };

  const onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ESCAPE_KEY) {
      props.closeReasonModelCallBack();
      hideAlertCallBack();
    }
  };

  return (
    <div onKeyDown={onKeyDown}>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel5"}
        isModulePopup={false}
        closeOnEsc={true}
        isShowPopup={props.isShowPopup}
        title={props.title}
        closeAlertModalCallBack={handleAfterClose}
        alertContainerBox={
          <AlertToolBox
            alertMsgList={alertMessage}
            alertErrorType={alertType}
            isShowAlert={isShowAlert}
            hideAlertCallBack={hideAlertCallBack}
          />
        }
        headerButtonContainer={
          <div className="floatLeft">
            <Button
              className="header_buttons enterFocus"
              size="sm"
              onClick={(e) => onClick(e)}
            >
              Continue
            </Button>
          </div>
        }
        content={
          <div>
            <Row>
              <Col sm="3">
                <FormLabel>Reason</FormLabel>
              </Col>
              <Col sm="8">
                <InputTextbox
                  name="code"
                  placeholder="Enter Reason"
                  // onChange={(e) => props.onChange(e)}
                  onChange={onChange}
                  value={props.reasonData.code}
                  lookupRequired={true}
                  lookupHandler={reasonLookupHandler}
                  enterKeyEventHandler={props.reasonEnterKeyEventHandler}
                  autoCompleteListData={props.reasonPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={props.displayAutoCompleteReasonList}
                  showAutoCompleteList={props.showAutoCompleteReasonList}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row className="h-100">
              <Col sm="3">
                <FormLabel>Description</FormLabel>
              </Col>

              <Col sm="8">
                <textarea
                  rows="3"
                  className="form-control"
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  onChange={onReasonDescChange}
                  value={props.reasonData.description}
                />
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export class BootstrapDataGridColumnDefinition {
  constructor() {
    this.columnDisplayName = "";
    this.columnBindingPropertyName = "";
    this.columnType = "";
    this.editable = false;
    this.columnAlignment = 0;
    this.sortColumn = false;
    this.hyperLinkCallback = null;
    this.getStatusCaption = null;
    this.buttonIcon = null;
    this.buttonClickCallback = null;
    this.columnOnClickLink = null;
    this.columnOnChangeLink = null;
    this.columnOnKeyDownLink = null;
    this.columnOnBlurLink = null;
    this.width = null;
    this.disabled = false;
  }
  setDetails = (columnDisplayName = "", columnBindingPropertyName = "") => {
    this.columnDisplayName = columnDisplayName;
    this.columnBindingPropertyName = columnBindingPropertyName;
    return this;
  };
  setWidth = (width = "") => {
    this.width = width;
    return this;
  };
  setEditable = (editable = false) => {
    this.editable = editable;
    return this;
  };
  setColumnAlignment = (columnAlignment = 0) => {
    this.columnAlignment = columnAlignment;
    return this;
  };
  setSortColumn = (sortColumn = false) => {
    this.sortColumn = sortColumn;
    return this;
  };
  setColumnType = (columnType = "") => {
    this.columnType = columnType;
    return this;
  };
  callHyperLinkCallback = (hyperLinkCallback = null) => {
    this.hyperLinkCallback = hyperLinkCallback;
    return this;
  };
  setStatusCaptionConverter = (getStatusCaption = null) => {
    this.getStatusCaption = getStatusCaption;
    return this;
  };
  setButtonIcon = (buttonIcon = "") => {
    this.buttonIcon = buttonIcon;
    return this;
  };
  setButtonClickCallback = (buttonClickCallback = null) => {
    this.buttonClickCallback = buttonClickCallback;
    return this;
  };
  setColumnOnClickLink = (columnOnClickLink = null) => {
    this.columnOnClickLink = columnOnClickLink;
    return this;
  };
  setColumnOnChangeLink = (columnOnChangeLink = null) => {
    this.columnOnChangeLink = columnOnChangeLink;
    return this;
  };
  setColumnOnKeyDownLink = (columnOnKeyDownLink = null) => {
    this.columnOnKeyDownLink = columnOnKeyDownLink;
    return this;
  };
  setColumnOnBlurLink = (columnOnBlurLink = null) => {
    this.columnOnBlurLink = columnOnBlurLink;
    return this;
  };
  setColumnAutoCompleteValues = (
    columnAutoCompleteLookUpValues = null,
    columnAutoCompleteValueProperty = "",
  ) => {
    this.columnAutoCompleteLookUpValues = columnAutoCompleteLookUpValues;
    this.columnAutoCompleteValueProperty = columnAutoCompleteValueProperty;
    return this;
  };
  setColumnAutoCompleteDynamicSearchLink = (
    columnAutoCompleteDynamicSearchLink = null,
  ) => {
    this.columnAutoCompleteDynamicSearchLink =
      columnAutoCompleteDynamicSearchLink;
    return this;
  };
  setDisabled = (disabled = false) => {
    this.disabled = disabled;
    return this;
  };
}

export class BootstrapDataGrid extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }
  cellFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <span>
        <strong>{cell}</strong>
      </span>
      // <NumberFormatInputbox
      //   name={columnBindingPropertyName}
      //   onChange={(evt) => this.onChange(evt, columnDef, row)}
      //   onClick={(evt) => this.onClick(evt, columnDef, row)}
      //   onKeyDown={(evt) => this.onKeyDown(evt, columnDef, row)}
      //   onBlur={(evt) => this.onBlur(evt, columnDef, row)}
      //   className="text-right col-sm-12"
      //   value={row[columnDef.columnBindingPropertyName]}
      //   decimalScale={2}
      //   disabled={columnDef.disableTargetColumn}
      // />
    );
  }

  formatCells = (tempDataGridColumnDef, columnDef) => {
    if (columnDef.columnType == "AutoComplete") {
      tempDataGridColumnDef.formatter = (
        cell,
        row,
        rowIndex,
        formatExtraData,
      ) => {
        return (
          <AutoCompleteTextbox
            name={columnDef.columnBindingPropertyName}
            placeholder={"Enter " + columnDef.columnBindingPropertyName}
            onChange={(evt) => this.onChange(evt, columnDef, row)}
            readOnly={columnDef.disableTargetColumn}
            defaultValue={row[columnDef.columnBindingPropertyName]}
            lookupValues={columnDef.columnAutoCompleteLookUpValues}
            valuePropery={columnDef.columnAutoCompleteValueProperty}
          />
        );
      };
    }
    if (columnDef.columnType == "DynamicAutoComplete") {
      tempDataGridColumnDef.formatter = (
        cell,
        row,
        rowIndex,
        formatExtraData,
      ) => {
        return (
          <DynamicAutoCompleteTextbox
            ref={this.customerCodeRef}
            name={columnDef.columnBindingPropertyName}
            placeholder={"Select" + columnDef.columnBindingPropertyName}
            onChange={(evt) => this.onChange(evt, columnDef, row)}
            readOnly={columnDef.disableColumn}
            disabled={columnDef.disableColumn}
            defaultValue={row[columnDef.columnBindingPropertyName]}
            lookupValues={columnDef.columnAutoCompleteLookUpValues}
            //isLoading={true}
            handleSearch={(searchString) =>
              this.onSearch(searchString, columnDef, row)
            }
            onFocus={(evt) => this.onFocus(evt, columnDef, row)}
            valuePropery={columnDef.columnAutoCompleteValueProperty}
            descriptionProperty={columnDef.columnAutoCompleteValueProperty}
          />
        );
      };
    }
    if (columnDef.columnType == "Number") {
      tempDataGridColumnDef.formatter = (
        cell,
        row,
        rowIndex,
        formatExtraData,
      ) => {
        return (
          <NumberFormatInputbox
            name={columnDef.columnBindingPropertyName}
            onChange={(evt) => this.onChange(evt, columnDef, row)}
            onClick={(evt) => this.onClick(evt, columnDef, row)}
            onKeyDown={(evt) => this.onKeyDown(evt, columnDef, row)}
            onBlur={(evt) => this.onBlur(evt, columnDef, row)}
            // className="text-right col-sm-12"
            value={row[columnDef.columnBindingPropertyName]}
            decimalScale={2}
            // isCustomHandledKeyDown={}
            // disabled={columnDef.disableTargetColumn}
          />
        );
      };
    }
    if (columnDef.columnType == "hyperLink") {
      tempDataGridColumnDef.formatter = (
        cell,
        row,
        rowIndex,
        formatExtraData,
      ) => {
        return (
          <span
            className="dataGridHyperLink"
            onClick={(evt) => this.onHyperLinkClick(evt, columnDef, row)}
          >
            {row[columnDef.columnBindingPropertyName]}
          </span>
        );
      };
    }
  };

  onChange = (evt, columnDef, row) => {
    if (evt && evt.target) {
      if (!!columnDef.columnOnChangeLink) {
        columnDef.columnOnChangeLink(evt, row);
      }
    }
  };

  onBlur = (evt, columnDef, row) => {
    if (evt && evt.target) {
      if (!!columnDef.columnOnBlurLink) {
        columnDef.columnOnBlurLink(evt, row);
      }
    }
  };

  hyperLinkColumnCell = (tempDataGridColumnDef, columnDef) => {
    tempDataGridColumnDef.formatter = (
      cell,
      row,
      rowIndex,
      formatExtraData,
    ) => {
      return (
        <span
          className="dataGridHyperLink"
          onClick={(evt) => this.onHyperLinkClick(evt, columnDef, row)}
        >
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
    };
  };

  onHyperLinkClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      let selectedValue = e.target.innerText;
      if (!!columnDef.hyperLinkCallback) {
        columnDef.hyperLinkCallback(selectedValue, rowData);
      }
    }
  };

  buttonColumnCell = (tempDataGridColumnDef, columnDef) => {
    tempDataGridColumnDef.formatter = (
      cell,
      row,
      rowIndex,
      formatExtraData,
    ) => {
      return (
        <Button
          data-tag="allowRowEvents"
          onClick={(evt) => this.onButtonClick(evt, columnDef, row)}
        >
          {columnDef.buttonIcon}
        </Button>
      );
    };
  };

  statusColumnCell = (tempDataGridColumnDef, columnDef) => {
    tempDataGridColumnDef.formatter = (
      cell,
      row,
      rowIndex,
      formatExtraData,
    ) => {
      return (
        <span>
          {this.getStatusCaption(
            columnDef,
            row[columnDef.columnBindingPropertyName],
          )}
        </span>
      );
    };
  };

  checkBoxColumnCell = (tempDataGridColumnDef, columnDef) => {
    tempDataGridColumnDef.formatter = (
      cell,
      row,
      rowIndex,
      formatExtraData,
    ) => {
      return (
        <InputCheckbox
          name={columnDef.columnBindingPropertyName}
          data-tag="allowRowEvents"
          onChange={(evt) => this.onChange(evt, columnDef, row)}
          checked={row[columnDef.columnBindingPropertyName]}
          disabled={columnDef.disabled}
        ></InputCheckbox>
      );
    };
  };

  onCellCheckBoxClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.checkBoxClickCallback) {
        rowData[columnDef.columnBindingPropertyName] = e.target.value;
        columnDef.checkBoxClickCallback(e, rowData);
      }
    }
  };

  getStatusCaption = (columnDef, status) => {
    if (!!columnDef.getStatusCaption) {
      let finalStatus = columnDef.getStatusCaption(status);
      return finalStatus;
    }
  };

  onButtonClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.buttonClickCallback) {
        columnDef.buttonClickCallback(e, rowData);
      }
    }
  };

  toBootstrapColumnDefinitions = (columnDef) => {
    let tempDataGridColumnDef = {
      dataField: columnDef.columnBindingPropertyName,
      text: columnDef.columnDisplayName,
      // editable: columnDef.editable,
      align: columnDef.columnAlignment,
      sort: columnDef.sortColumn,
      style: { width: columnDef.width, maxWidth: columnDef.width },
      headerStyle: { width: columnDef.width, maxWidth: columnDef.width },
    };
    if (columnDef.editable) {
      this.formatCells(tempDataGridColumnDef, columnDef);
    }

    if (columnDef.columnAlignment == 1) {
      tempDataGridColumnDef.align = "right"; // table cell align
      tempDataGridColumnDef.headerAlign = "right"; // table header cell align
    }

    if (columnDef.columnType == "hyperLink") {
      this.hyperLinkColumnCell(tempDataGridColumnDef, columnDef);
    }

    if (columnDef.columnType == "statusColumn") {
      this.statusColumnCell(tempDataGridColumnDef, columnDef);
    }

    if (columnDef.columnType == "button") {
      this.buttonColumnCell(tempDataGridColumnDef, columnDef);
    }
    if (columnDef.columnType == "number") {
      this.formatCells(tempDataGridColumnDef, columnDef);
    }
    if (columnDef.columnType == "checkBox") {
      this.checkBoxColumnCell(tempDataGridColumnDef, columnDef);
    }

    tempDataGridColumnDef.events = {
      onFocus: (e, column, columnIndex, row, rowIndex) => {},
      onKeyDown: (e, column, columnIndex, row, rowIndex) => {},
    };
    return tempDataGridColumnDef;
  };
  // rowEvents = {
  //   onClick: (e, row, rowIndex) => {
  //   },
  //   onFocus: (e) => {
  //   },
  //   onKeyDown: (e) => {
  //   },
  // };
  render() {
    let dataGridColumnList = [];
    if (this.props.columnsList) {
      this.props.columnsList.map((cdef) =>
        dataGridColumnList.push(this.toBootstrapColumnDefinitions(cdef)),
      );
    }
    return (
      <BootstrapTable
        keyField={this.props.id}
        data={this.props.dataList}
        columns={dataGridColumnList}
        //cellEdit={cellEditFactory({
        //mode: "click",
        // blurToSave: true,
        //})}
        // rowEvents={this.rowEvents}
      />
    );
  }
}

export const ModulePopup = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.isShowModule == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  const closeModal = () => {
    props.closeModalCallBack(false);
    setOpen(false);
  };

  return (
    <div>
      <Popup
        id={props.id}
        open={open}
        closeOnDocumentClick
        onClose={closeModal}
        repositionOnResize={true}
        position="center center"
      >
        <div className="modal">
          <button className="close" onClick={closeModal}>
            &times;
          </button>
          <div className="content">
            {props.module !== null &&
              props.module !== undefined &&
              props.module}
          </div>
        </div>
      </Popup>
    </div>
  );
};

export const AlertModulePopup = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.isShowAlert == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  const closeModal = () => {
    props.closeAlertModalCallBack(false);
    setOpen(false);
  };

  return (
    <div>
      <Popup
        id={props.id}
        open={props.isShowAlert}
        closeOnDocumentClick
        onClose={closeModal}
        repositionOnResize={true}
        position="bottom left"
      >
        <div className="modal">
          <button className="close" onClick={closeModal}>
            &times;
          </button>
          <div className="content">{props.content}</div>
        </div>
      </Popup>
    </div>
  );
};

export const SimplePopup = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  const closeModal = () => {
    props.closeAlertModalCallBack(false);
    setOpen(false);
  };
  return (
    <>
      <div>
        <Popup
          id={props.id}
          open={open}
          closeOnDocumentClick={props.closeOnDocumentClick}
          onClose={closeModal}
          repositionOnResize={true}
          position="center center"
          closeOnEscape={props.closeOnEsc}
          className={props.popupLvlClass ? props.popupLvlClass : "simplePopup"}
          nested={true}
        >
          <div className="modal">
            <button className="close" onClick={closeModal}>
              &times;
            </button>

            <div className="moduleContainer" id="moduleContainer">
              <div className="modalHeaderWithButtons">
                <div className="modalButtonContainer modalLeftSideHeader">
                  {props.headerButtonContainer && (
                    <div>{props.headerButtonContainer}</div>
                  )}
                </div>
                <div className="modalTitle">{props.title}</div>
                <div className="modalRightSideHeader"></div>
              </div>
              <div>{props.alertContainerBox}</div>
              <div className="content">{props.content}</div>
            </div>
          </div>
        </Popup>
      </div>
    </>
  );
};

export const ShortCutMenuPopup = (props) => {
  const [open, setOpen] = useState(false);
  const shortCutRef = useRef();
  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  const closeModal = () => {
    // props.closeAlertModalCallBack(false);

    shortCutRef.current.close();
  };

  return (
    <div>
      <Popup
        ref={shortCutRef}
        trigger={
          <div className="menu-item circle-button">
            {" "}
            <AddIcon />{" "}
          </div>
        }
        position="bottom left"
        on="click"
        closeOnDocumentClick={true}
        mouseLeaveDelay={300}
        mouseEnterDelay={0}
        contentStyle={{ padding: "0px", border: "none" }}
        arrow={false}
        className="shortCutMenu"
        open={false}
      >
        {props.value && (
          <div className="shortCutMenuItems" onClick={closeModal}>
            {props.menuItems}
          </div>
        )}
      </Popup>
    </div>
  );
};

export const ShortCutMenuPopupV1 = (props) => {
  const [open, setOpen] = useState(false);
  const shortCutRef = useRef();
  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });
  const closeModal = () => {
    shortCutRef.current.close();
  };

  return (
    <div>
      <Popup
        ref={shortCutRef}
        trigger={
          <div className="menu-item circle-button">
            <AddIcon />{" "}
          </div>
        }
        position="bottom left"
        on="click"
        closeOnDocumentClick={true}
        mouseLeaveDelay={300}
        mouseEnterDelay={0}
        contentStyle={{ padding: "0px", border: "none" }}
        arrow={false}
        className="shortCutMenu"
        open={false}
      >
        {props.value && (
          <div className="shortCutMenuItems" onClick={closeModal}>
            {props.menuItems}
          </div>
        )}
      </Popup>
    </div>
  );
};

//#region AlertToolBox
export class AlertToolBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertErrorMsgList: this.props.alertMsgList,
      alertErrorType: this.props.alertErrorType,
      isShowAlert: this.props.isShowAlert,
      errorClass: "",
    };
  }

  handleAlert = (msgType, isDisplayed) => {
    this.props.hideAlertCallBack(msgType, isDisplayed);
  };

  render() {
    let errorClass = this.state.errorClass;

    return (
      <div>
        {this.props.alertErrorType == "success" &&
        this.props.alertMsgList !== null &&
        this.props.alertMsgList.length > 0 ? (
          <SuccessAlert
            alertMsgList={this.props.alertMsgList}
            alertErrorType={this.props.alertErrorType}
            isShowAlert={this.props.isShowAlert}
            showAlertCallBack={this.handleAlert}
          />
        ) : (
          ""
        )}

        {this.props.alertErrorType == "danger" &&
        this.props.alertMsgList !== null &&
        this.props.alertMsgList.length > 0 ? (
          <DangerAlert
            alertMsgList={this.props.alertMsgList}
            alertErrorType={this.props.alertErrorType}
            isShowAlert={this.props.isShowAlert}
            showAlertCallBack={this.handleAlert}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export class SuccessAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMsgList: this.props.alertMsgList,
      alertErrorType: this.props.alertErrorType,
      isShowAlert: this.props.isShowAlert,
      errorClass: "",
    };
  }

  handleClearError = () => {
    this.props.showAlertCallBack(this.props.alertErrorType, false);
  };

  render() {
    let success_list = this.props.alertMsgList;

    if (success_list == null) {
      success_list = new Array();
    }
    return (
      <div>
        {this.props.isShowAlert && success_list !== null ? (
          <div className="successAlert" id="successAlert">
            <div>
              <div className="err-wrp">
                <div className="scss-icn-wrp">
                  <SUCCESSICON />
                </div>
                <div className="err-lst">
                  {success_list.map((success, index) => (
                    <li key={index} className="">
                      {success}
                    </li>
                  ))}
                </div>
              </div>
            </div>
            <div>
              {" "}
              <Button
                id="successMsgId"
                className="err-cls-btn"
                onClick={() => this.handleClearError()}
              >
                <CLOSEICON />
              </Button>
            </div>
          </div>
        ) : (
          // <div className="successAlert">
          //   <ul>
          //     {success_list.map((success, index) => (
          //       <li key={index} className="successNotificationBar">
          //         {success}
          //       </li>
          //     ))}
          //   </ul>
          //   {/* <span>{this.props.alertErrorMsg}</span> */}
          //   <span className="alert_btn_span">
          //     <Button id="successMsgId" onClick={() => this.handleClearError()}>
          //       Clear
          //     </Button>
          //   </span>
          // </div>
          ""
        )}
      </div>
    );
  }
}

export class DangerAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMsgList: this.props.alertMsgList,
      alertErrorType: this.props.alertErrorType,
      isShowAlert: this.props.isShowAlert,
      errorClass: "",
    };
  }

  handleClearError = () => {
    this.props.showAlertCallBack(this.props.alertErrorType, false);
  };

  render() {
    let error_list = this.props.alertMsgList;

    if (error_list == null) {
      error_list = new Array();
    }
    return (
      <div>
        {this.props.isShowAlert && error_list !== null ? (
          <div className="dangerAlert" id="dangerAlert">
            <div>
              <div className="err-wrp">
                <div className="err-icn-wrp">
                  <ERRORICON />
                </div>
                <div className="err-lst">
                  <ul>
                    {error_list.map((error, index) => (
                      <li key={index} className="dangerNotificationBar">
                        {error}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div>
              {" "}
              <Button
                id="successMsgId"
                className="err-cls-btn"
                onClick={() => this.handleClearError()}
              >
                <CLOSEICON />
              </Button>
            </div>
            {/* <span>{this.props.alertErrorMsg}</span> */}
            {/* <span className="alert_btn_span">
              <Button id="successMsgId" onClick={() => this.handleClearError()}>
                Clear
              </Button>
            </span> */}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export const MultiViewPopup = (props) => {
  const [open, setOpen] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    if (popupRef.current) popupRef.current.focus();
  });
  //const modulePopupRef = useRef();
  // const modulePopupCloseBtnRef = useRef(null);
  // const modulePopupCloseInputRef = useRef(null);
  // useEffect(() => {
  //   if (props.isShowPopup == false) {
  //     setOpen(false);
  //   } else {
  //     setOpen(true);
  //   }
  // });

  const Loader = (props) => {
    let progressText = "Loading ...";
    if (!!props.loadingText) {
      progressText = props.loadingText;
    }

    return (
      <div className="popup_loader">
        <div className="loaderText">
          <span>{progressText}</span>
          <div class="spinner"></div>
        </div>
      </div>
    );
  };

  const closeModal = () => {
    // if (modulePopupCloseInputRef.current) {
    //   modulePopupCloseInputRef.current.focus();
    // }
    if (
      props.isModulePopup
        ? props.closeModalCallBack(false)
        : props.closeAlertModalCallBack(false)
    );
    setOpen(false);
    // focusCloseInput();
  };

  // const focusCloseInput = () => {
  //   setTimeout(() => {
  //     let lvlClass = props.popupLvlClass
  //       ? props.popupLvlClass + "-content"
  //       : "simplePopup-content";

  //     let popupContents = document.querySelectorAll(
  //       ".popup-content > .testSpan > .modal > .popupCloseInput"
  //     );
  //     if (popupContents != undefined && popupContents != null) {
  //       let finalPopup = popupContents[popupContents.length - 1];
  //       if (finalPopup != undefined && finalPopup != null) {
  //         finalPopup.focus();
  //       }
  //     }
  //   }, 100);
  // };

  // const onKeyDown = (e) => {
  //   // if (e.keyCode == KeyConstants.ESCAPE_KEY) {
  //   //   if (modulePopupCloseBtnRef.current) {
  //   //     modulePopupCloseBtnRef.current.click();
  //   //   }
  //   //   e.stopPropagation();
  //   //   e.nativeEvent.stopImmediatePropagation();
  //     //closeModal(e);
  //     // focusCloseInput();
  //     document.body.style.overflow = "unset";
  //   // }
  // };
  const onKeyDown = (e) => {
    if (e.keyCode === KeyConstants.ESCAPE_KEY) {
      closeModal();
    }
  };

  return (
    <>
      <div
        className="testForPopup"
        onKeyDown={(e) => onKeyDown(e)}
        ref={popupRef}
      >
        <Popup
          id={props.id}
          open={props.isShowPopup}
          closeOnDocumentClick={false}
          repositionOnResize={true}
          position="center center"
          closeOnEscape={false}
          lockScroll={true}
          className={props.popupLvlClass ? props.popupLvlClass : "simplePopup"}
          nested={true}
          disabled={props.disabled}
        >
          <span className="testSpan">
            <div className="modal">
              {props.showCloseButton !== false && (
                <button className="close" onClick={closeModal}>
                  &times;
                </button>
              )}

              {props.isModulePopup ? (
                <div className="content">
                  {props.module !== null &&
                    props.module !== undefined &&
                    props.module}
                </div>
              ) : (
                <div className="moduleContainer" id="moduleContainer">
                  <div className="modalHeaderWithButtons">
                    <div className="modalButtonContainer modalLeftSideHeader">
                      {props.headerButtonContainer && (
                        <div>{props.headerButtonContainer}</div>
                      )}
                    </div>
                    <div className="modalTitle">{props.title}</div>
                    {props.isLoading ? (
                      <Loader loadingText={props.loadingText} />
                    ) : null}

                    <div className="modalRightSideHeader"></div>
                  </div>
                  <div>{props.alertContainerBox}</div>

                  <div className="content">{props.content}</div>
                </div>
              )}

              {props.isLookup ? (
                <div className="lookup-wrap">
                  <div className="content">
                    <div className="header-cnt">{props.headercontent}</div>
                    <div className="page-cnt"> {props.paginationContent}</div>
                    <div className="result-cnt"> {props.resultContent}</div>
                  </div>
                  {/* <Popup
                    id={props.id}
                    open={true}
                    closeOnDocumentClick={false}
                    repositionOnResize={true}
                    position="center center"
                    closeOnEscape={false}
                    lockScroll={true}
                    className={"simplePopup popupSizeLevel0 criteria-box"}
                    nested={true}
                  >
                    hiii
                  </Popup> */}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </span>
        </Popup>
      </div>
    </>
  );
};

export const MultiViewPopup_bkup_15Jun2022 = (props) => {
  const [open, setOpen] = useState(false);
  //const modulePopupRef = useRef();
  const modulePopupCloseBtnRef = useRef(null);
  const modulePopupCloseInputRef = useRef(null);
  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  const closeModal = () => {
    if (modulePopupCloseInputRef.current) {
      modulePopupCloseInputRef.current.focus();
    }
    if (
      props.isModulePopup
        ? props.closeModalCallBack(false)
        : props.closeAlertModalCallBack(false)
    );

    setOpen(false);
    focusCloseInput();
  };

  const focusCloseInput = () => {
    setTimeout(() => {
      let popupContents = document.querySelectorAll(
        ".simplePopup-content > .testSpan > .modal > .popupCloseInput",
      );

      if (popupContents != undefined && popupContents != null) {
        let finalPopup = popupContents[popupContents.length - 1];
        if (finalPopup != undefined && finalPopup != null) {
          finalPopup.focus();
        }
      }
    }, 100);
  };

  const onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ESCAPE_KEY) {
      if (modulePopupCloseBtnRef.current) {
        modulePopupCloseBtnRef.current.click();
      }
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      //closeModal(e);
      focusCloseInput();
    }
  };

  const onOpen = () => {};

  const onClick = () => {
    // focusCloseInput();
  };

  return (
    <>
      <div className="testForPopup">
        <Popup
          //ref={modulePopupRef}
          id={props.id}
          open={open}
          // closeOnDocumentClick={props.closeOnDocumentClick}
          // onClose={closeModal}
          repositionOnResize={true}
          position="center center"
          closeOnEscape={false}
          className={props.popupLvlClass ? props.popupLvlClass : "simplePopup"}
          nested={true}
          disabled={props.disabled}
          //onOpen={onOpen}
        >
          <span className="testSpan" onKeyDown={onKeyDown}>
            <div className="modal">
              <input
                className="popupCloseInput"
                name="popupCloseInput"
                ref={modulePopupCloseInputRef}
              ></input>
              <button
                ref={modulePopupCloseBtnRef}
                className="close"
                onClick={closeModal}
              >
                &times;
              </button>

              {props.isModulePopup ? (
                <div className="content">
                  {props.module !== null &&
                    props.module !== undefined &&
                    props.module}
                </div>
              ) : (
                <div className="moduleContainer" id="moduleContainer">
                  <div className="modalHeaderWithButtons">
                    <div className="modalButtonContainer modalLeftSideHeader">
                      {props.headerButtonContainer && (
                        <div>{props.headerButtonContainer}</div>
                      )}
                    </div>
                    <div className="modalTitle">{props.title}</div>
                    <div className="modalRightSideHeader"></div>
                  </div>
                  <div>{props.alertContainerBox}</div>
                  <div className="content">{props.content}</div>
                </div>
              )}
            </div>
          </span>
        </Popup>
      </div>
    </>
  );
};

export const ProgressBar = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.isShowPopup == false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  });

  let progressText = props.progressLoadingText;
  return (
    <>
      <div className="progressBar">
        <Popup
          id={props.id}
          open={open}
          repositionOnResize={true}
          position="center center"
          closeOnEscape={false}
          className="progressBar"
          nested={true}
          disabled={props.disabled}
        >
          <div className="progressBarTitle">
            <span>{progressText}</span>
            <div class="progress-bar">
              <span class="bar">
                <span class="progress"></span>
              </span>
            </div>
          </div>
        </Popup>
      </div>
    </>
  );
};

// export const TimePickerComponent = (props) => {
//   const [time, setTime] = useState(props.value); // Default time value

//   // const inputRef = useRef(null);
//   // useEffect(() => {
//   //   // let currentDate = new Date();
//   //   let time_ = new Date().getHours() + ":" + new Date().getMinutes();
//   //   // time = time.toLocaleString();

//   //   setTime(time);
//   // }, []);
//   // useEffect(() => {
//   //   if (inputRef.current) inputRef.current.focus();
//   // }, []);

//   // const handleTimeChange = (event) => {
//   //   setTime(event.target.value);
//   // };
//   const pad = (d) => {
//     return d < 10 ? "0" + d.toString() : d.toString();
//   };
//   // const handleTimeChange = (event) => {
//   //   const inputValue = event.target.value;
//   //   const [hours, minutes] = inputValue.split(":");
//   //   let formattedHours = parseInt(hours, 10);
//   //   //   const period = formattedHours >= 12 ? "PM" : "AM";

//   //   if (formattedHours > 12) {
//   //     formattedHours -= 12;
//   //   } else if (formattedHours === 0) {
//   //     formattedHours = 12;
//   //   }

//   //   // const formattedTime = `${formattedHours}:${minutes} ${period}`;
//   //   const formattedTime = `${pad(formattedHours)}:${minutes}`;
//   //   setTime(formattedTime);
//   // };
//   const handleKeyDown = (event) => {
//     if (
//       event.keyCode == KeyConstants.ENTER_KEY ||
//       event.keyCode == KeyConstants.TAB_KEY
//     ) {
//       let currentDate = new Date();
//       // if (!isEmptyString(props.value)) {
//       let time = currentDate.getHours() + ":" + currentDate.getMinutes();
//       time = time.toLocaleString();

//       setTime(time);
//       focusNextElement();
//       // }
//     }
//   };

//   return (
//     <div>
//       {/* <TimePicker onChange={handleTimeChange} value={time} /> */}
//       {/* <input type="time" value={time} onChange={handleTimeChange} /> */}
//       {/* <input
//         type="text"
//         pattern="[0-9]{2}:[0-9]{2} [APap][Mm]"
//         placeholder="hh:mm AM/PM"
//         value={time}
//         onChange={handleTimeChange}
//       /> */}
//       {/* <p>Selected Time: {time}</p> */}

//       <FormControl
//         ref={props.ref}
//         type="time"
//         // value={props.value}
//         value={time}
//         name={props.name}
//         // style={style}
//         onChange={props.onChange}
//         readOnly={props.disabled}
//         disabled={props.disabled}
//         onKeyDown={handleKeyDown}
//       />
//     </div>
//   );
// };

export const TimePickerComponent = (props) => {
  const [time, setTime] = useState(props.value);

  // const inputRef = useRef(null);

  // useEffect(() => {
  //   if (inputRef.current) inputRef.current.focus();
  // }, []);
  // useEffect(() => {
  //   let currentDate = new Date();
  //   let time = currentDate.getHours() + ":" + currentDate.getMinutes();
  //   // time = time.toLocaleString();

  //   setTime(time);
  // }, []);
  // const handleTimeChange = (event) => {
  //   setTime(event.target.value);
  // };
  const pad = (d) => {
    return d < 10 ? "0" + d.toString() : d.toString();
  };
  // const handleTimeChange = (event) => {
  //   const inputValue = event.target.value;
  //   const [hours, minutes] = inputValue.split(":");
  //   let formattedHours = parseInt(hours, 10);
  //   //   const period = formattedHours >= 12 ? "PM" : "AM";

  //   if (formattedHours > 12) {
  //     formattedHours -= 12;
  //   } else if (formattedHours === 0) {
  //     formattedHours = 12;
  //   }

  //   // const formattedTime = `${formattedHours}:${minutes} ${period}`;
  //   const formattedTime = `${pad(formattedHours)}:${minutes}`;
  //   setTime(formattedTime);
  // };
  const handleKeyDown = (event) => {
    if (
      event.keyCode == KeyConstants.ENTER_KEY ||
      event.keyCode == KeyConstants.TAB_KEY
    ) {
      if (isEmptyString(props.value)) {
        if (props.enterKeyEventHandler) {
          props.enterKeyEventHandler();
        }
        focusNextElement();
      } else {
        focusNextElement();
      }
    }
  };

  return (
    <div>
      <FormControl
        ref={props.ref}
        type="time"
        value={props.value}
        name={props.name}
        onChange={props.onChange}
        readOnly={props.disabled}
        disabled={props.disabled}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export class ColumnDefinition {
  constructor() {
    this.header = "";
    this.isHeaderButton = false;
    this.headerRender = null;
    this.headerClickHandler = null;
    this.headerDisable = null;
    this.accessor = "";
    this.sortable = false;
    this.isNumeric = false;
    this.alignment = "";
    this.isHyperLink = false;
    this.isButton = false;
    this.clickHandler = null;
    this.buttonRender = null;
    this.isInputTexBox = false;
    this.isCheckBox = false;
    this.isNumberFormat = false;
    this.decimalScale = null;
    this.inputOnChange = null;
    this.checkBoxOnChange = null;
    this.inputOnBlur = null;
    this.isImage = false;
    this.getImageUrl = null;
    this.imageLinkCallBack = null;
    this.mininWidth = "";
    this.maxWidth = "";
    this.isStatus = false;
    this.getStatusCaption = null;
    this.isGraph = false;
    this.getGraph = null;
    this.customStyle = "";
    this.headerStyle = "";
    this.isSubHeader = "";
    this.subHeaderAccessor = "";
    this.isColSpan = false;
    this.isTopHeader = false;
    this.colSpan = 0;
    this.isSpecial = false;
    this.specialAccessor = "";
    this.disable = false;
    this.shortCutPopUpMenu = false;
    this.isDateFormate = false;
	this.isCalculated = false;
    this.getCalculatedValue = null;
	this.isSpecialDisabled = false;
    this.getDisabled = null;
	this.isDocument = false;
  }

  setDetails_old = (header, accessor, sortable, isNumeric, isDateFormate) => {
    this.header = header;
    this.accessor = accessor;
    this.sortable = sortable;
    this.isNumeric = isNumeric;
    this.isDateFormate = isDateFormate;
    return this;
  };

  setDetails = (
    header,
    accessor,
    sortable,
    isNumeric,
    isDateFormate,
    pre_currency,
  ) => {
    this.header = header;
    this.accessor = accessor;
    this.sortable = sortable;
    this.isNumeric = isNumeric;
    this.isDateFormate = isDateFormate;
    this.pre_currency = pre_currency;
    return this;
  };

  setHeaderDetails = (
    isHeaderButton,
    headerRender,
    headerClickHandler,
    headerDisable,
  ) => {
    this.isHeaderButton = isHeaderButton;
    this.headerRender = headerRender;
    this.headerClickHandler = headerClickHandler;
    this.headerDisable = headerDisable;
    return this;
  };

  setSubHeaderDetails = (isSubHeader, subHeaderAccessor) => {
    this.isSubHeader = isSubHeader;
    this.subHeaderAccessor = subHeaderAccessor;
    return this;
  };

  setStyleDetails = (
    alignment,
    mininWidth,
    maxWidth,
    customStyle,
    headerStyle,
  ) => {
    this.alignment = alignment;
    this.mininWidth = mininWidth;
    this.maxWidth = maxWidth;
    this.customStyle = customStyle;
    this.headerStyle = headerStyle;
    return this;
  };

  setSpanDetails = (isColSpan, isTopHeader, colSpan) => {
    this.isColSpan = isColSpan;
    this.isTopHeader = isTopHeader;
    this.colSpan = colSpan;
    return this;
  };

  setInputDetails = (
    isInputTexBox,
    isNumberFormat,
    isCheckBox,
    inputOnChange,
    checkBoxOnChange,
    inputOnBlur,
    decimalScale,
  ) => {
    this.isInputTexBox = isInputTexBox;
    this.isNumberFormat = isNumberFormat;
    this.isCheckBox = isCheckBox;
    this.inputOnChange = inputOnChange;
    this.checkBoxOnChange = checkBoxOnChange;
    this.inputOnBlur = inputOnBlur;
    this.decimalScale = decimalScale;
    return this;
  };

  setClickDetails = (isHyperLink, isButton, clickHandler, buttonRender) => {
    this.isHyperLink = isHyperLink;
    this.isButton = isButton;
    this.clickHandler = clickHandler;
    this.buttonRender = buttonRender;
    return this;
  };

  setShortCutPopDetails = (buttonRender, shortCutPopUpMenu) => {
    this.buttonRender = buttonRender;
    this.shortCutPopUpMenu = shortCutPopUpMenu;
    return this;
  };

  setImageDetails = (isImage, getImageUrl, imageLinkCallBack) => {
    this.isImage = isImage;
    this.getImageUrl = getImageUrl;
    this.imageLinkCallBack = imageLinkCallBack;
    return this;
  };

  setStatusDetails = (isStatus, getStatusCaption) => {
    this.isStatus = isStatus;
    this.getStatusCaption = getStatusCaption;
    return this;
  };

  setGraphDetails = (isGraph, getGraph) => {
    this.isGraph = isGraph;
    this.getGraph = getGraph;
    return this;
  };

  setSpecialDetails = (isSpecial, specialAccessor) => {
    this.isSpecial = isSpecial;
    this.specialAccessor = specialAccessor;
    return this;
  };
  
  setCalculatedDetails = (isCalculated, getCalculatedValue) => {
	  this.isCalculated = isCalculated;
	  this.getCalculatedValue = getCalculatedValue;
	  return this;
	};  
  
  setDisabled = (disable) => {
    this.disable = disable;
    return this;
  };
  
  setSpecialDisabled  = (isSpecialDisabled, getDisabled) => {
	  this.isSpecialDisabled = isSpecialDisabled;
	  this.getDisabled = getDisabled;
	  return this;
	};  

  setDocument = (isDocument)=>{
  this.isDocument = isDocument;
    return this;
  }
}

export const MailComponent = (props) => {
  const [mailData, setMailData] = useState(props.mailData);
  const [alertMessage, setAlertMessage] = useState(props.msgList || []);
  const [alertType, setAlertType] = useState(props.msgType || "");
  const [isShowAlert, setIsShowAlert] = useState(props.isShowAlert || false);
  const [isDisabled, setIsDisabled] = useState(props.isDisabled);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setMailData(props.mailData);
  }, [props.mailData]);

  useEffect(() => {
    setAlertMessage(props.msgList);
  }, [props.msgList]);

  useEffect(() => {
    setAlertType(props.msgType);
  }, [props.msgType]);

  useEffect(() => {
    setIsShowAlert(props.isShowAlert);
  }, [props.isShowAlert]);

  useEffect(() => {
    setIsDisabled(props.isDisabled);
  }, [props.isDisabled]);

  const handleAfterClose = () => {
    props.closeModelCallBack();
    hideAlertCallBack();
  };

  const onChange = (e) => {
    props.onChange(e);
  };

  const onClick = (e) => {
    if (e.detail == 1) {
      // setIsLoading(true);
      // const promiseThen = new Promise((resolve, reject) => {
      if (props.onClick) props.onClick(e);
      // });
      // console.log("promiseThen <<=>> ", promiseThen);
      // promiseThen
      //   .then((val) => {
      //     console.log(val);
      //     setIsLoading(false);
      //   })
      //   .catch((err) => console.log(err));
      // setIsLoading(false);
    }
  };

  const hideAlertCallBack = (msgType, isDisplayed) => {
    setIsShowAlert(false);
    setAlertMessage([]);
  };

  const onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ESCAPE_KEY) {
      props.closeModelCallBack();
      hideAlertCallBack();
    }
  };

  const closeAlertProgressBarModalCallBack = (isShowPopup) => {
    setIsLoading(false);
  };

  return (
    <div onKeyDown={onKeyDown}>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel3"}
        isModulePopup={false}
        closeOnEsc={true}
        isShowPopup={props.isShowPopup}
        title={props.title}
        closeAlertModalCallBack={handleAfterClose}
        alertContainerBox={
          <AlertToolBox
            alertMsgList={alertMessage}
            alertErrorType={alertType}
            isShowAlert={isShowAlert}
            hideAlertCallBack={hideAlertCallBack}
          />
        }
        headerButtonContainer={
          <div className="floatLeft">
            <Button
              className="header_buttons enterFocus"
              size="sm"
              onClick={(e) => onClick(e)}
            >
              Continue
            </Button>
          </div>
        }
        content={
          <div>
            {/* <>{isLoading ? "loading" : null}</> */}
            {/* <ProgressBar
              closeAlertModalCallBack={closeAlertProgressBarModalCallBack}
              progressLoadingText={""}
              isShowPopup={isLoading}
            /> */}
            <div>
              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>From</FormLabel>
                </Col>
                <Col sm="6">
                  <InputTextbox value={mailData.from} disabled={true} />
                </Col>
              </Row>
              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>To</FormLabel>
                </Col>
                <Col sm="10">
                  <InputTextbox
                    name="tos"
                    value={mailData.tos}
                    onChange={onChange}
                    disabled={isDisabled}
                    isMandatory={true}
                  />
                </Col>
              </Row>

              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>CCs</FormLabel>
                </Col>
                <Col sm="10">
                  <InputTextbox
                    name="ccs"
                    value={mailData.ccs}
                    onChange={onChange}
                    disabled={isDisabled}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>BCCs</FormLabel>
                </Col>
                <Col sm="10">
                  <InputTextbox
                    name="bccs"
                    value={mailData.bccs}
                    onChange={onChange}
                    disabled={isDisabled}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>Title</FormLabel>
                </Col>
                <Col sm="6">
                  <InputTextbox
                    name="title"
                    value={mailData.title}
                    onChange={onChange}
                    disabled={isDisabled}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1"></Col>
                <Col sm="1">
                  <FormLabel>Attachments</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1"></Col>

                <Col sm="6">
                  <textarea
                    rows={15}
                    cols={72}
                    name="message"
                    value={mailData.message}
                    onChange={onChange}
                    disabled={isDisabled}
                  />
                </Col>
              </Row>
            </div>
          </div>
        }
      />
    </div>
  );
};

export class EditableDataGrid_v1 extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  toDataGridColumn = (columnDef) => {
    let isRight = columnDef.columnAlignment == 1 ? true : false;
    let isCenter = columnDef.columnAlignment == 2 ? true : false;
    let tableHeaderAlign = "left";
    if (isRight) tableHeaderAlign = "right";
    else if (isCenter) tableHeaderAlign = "center";
    let tempDataGridColumnDef = {
      name: columnDef.columnDisplayName,
      //selector: columnDef.columnBindingPropertyName,
      selector: (row) => row[columnDef.columnBindingPropertyName],
      sortable: true,
      right: isRight,
      minWidth: columnDef.columnMinWidth,
      maxWidth: columnDef.columnMaxWidth,
      center: isCenter,
      wrap: true,
      tableHeaderAlign: tableHeaderAlign,
      style: columnDef.columnStyle,
      // conditionalCellStyles?: IDataTableConditionalCellStyles<T>[];
    };

    if (columnDef.buttonColumn === true) {
      // if (columnDef.sortable === true) {
      let cellDef = (row) => (
        <Button
          data-tag="allowRowEvents"
          onClick={(evt) => this.onButtonClick(evt, columnDef, row)}
          hidden={columnDef.columnDisabled}
        >
          {columnDef.columnBindingPropertyName}
        </Button>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
      /* } else {
        <FormLabel
          //data-tag="allowRowEvents"
          onClick={(evt) => this.onButtonClick(evt, columnDef)}
          // hidden={columnDef.columnDisabled}
        ></FormLabel>;
        // {columnDef.columnDisplayName}
 
        //  let cellDef = (row) => (
        /*  <Button
            //data-tag="allowRowEvents"
            onClick={(evt) => this.onButtonClick(evt, columnDef)}
           // hidden={columnDef.columnDisabled}
          >
           // {columnDef.columnDisplayName}
          </Button>
        //);
       // tempDataGridColumnDef.columnheader = cellDef;
        tempDataGridColumnDef.ignoreRowClick = true;
 
        return tempDataGridColumnDef;
      }*/
    }
    if (columnDef.inputBoxColumn === true) {
      let targetInputBoxName = columnDef.inputBoxTargetColumnName;

      let cellDef = (row) => (
        <NumberFormatInputbox
          name={targetInputBoxName}
          onChange={(e) => this.onInputBoxChange(e, columnDef, row)}
          onBlur={(evt) => this.onBlur(evt, columnDef, row)}
          className="text-right col-sm-12"
          value={row[columnDef.columnBindingPropertyName]}
          decimalScale={2}
          disabled={columnDef.columnDisabled}
        />
      );
      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }
    if (columnDef.imageColumn === true) {
      let cellDef = (row) => (
        <img
          src={this.onImageLinkCallBack(columnDef, row)}
          width={50}
          height={30}
          mode="fit"
        />
      );

      tempDataGridColumnDef.cell = cellDef;
      return tempDataGridColumnDef;
    }

    if (columnDef.hyperLinkcolumn === true) {
      let cellDef = (row) => (
        <span
          className="dataGridHyperLink"
          data-tag="allowRowEvents"
          onClick={(evt) => this.onHyperLinkClick(evt, columnDef, row)}
        >
          {row[columnDef.columnBindingPropertyName]}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
    }

    if (columnDef.checkBoxColumn === true) {
      let cellDef = (row) => (
        <InputCheckbox
          name={columnDef.columnBindingPropertyName}
          data-tag="allowRowEvents"
          onChange={(evt) => this.onCellCheckBoxClick(evt, columnDef, row)}
          checked={row[columnDef.columnBindingPropertyName]}
          disabled={columnDef.columnDisabled}
          disableLabel={true}
        ></InputCheckbox>
      );

      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;

      return tempDataGridColumnDef;
    }

    if (columnDef.statusColumn === true) {
      let cellDef = (row) => (
        <span>
          {this.getStatusCaption(
            columnDef,
            row[columnDef.columnBindingPropertyName],
          )}
        </span>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }
    if (columnDef.graphColumn === true) {
      let cellDef = (row) => (
        <div className="graph-wrap">
          {columnDef.graphValueProvider(columnDef, row)}
        </div>
      );
      tempDataGridColumnDef.cell = cellDef;
      tempDataGridColumnDef.ignoreRowClick = true;
    }
    return tempDataGridColumnDef;
  };

  getStatusCaption = (columnDef, status) => {
    if (!!columnDef.getStatusCaption) {
      let finalStatus = columnDef.getStatusCaption(status);
      return finalStatus;
    }
  };

  onInputBoxChange = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.inputChangeCallback) {
        columnDef.inputChangeCallback(e, rowData);
      }
    }
  };

  onBlur = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.inputBoxOnBlurCallback) {
        columnDef.inputBoxOnBlurCallback(e, rowData);
      }
    }
  };

  onHyperLinkClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      let selectedValue = e.target.innerText;
      if (!!columnDef.hyperLinkCallback) {
        columnDef.hyperLinkCallback(selectedValue, rowData);
      }
    }
  };

  onImageLinkCallBack = (columnDef, rowData) => {
    if (!!columnDef.imageLinkCallBack) {
      let col = columnDef.imageLinkCallBack(columnDef, rowData);
      return col;
    }
  };

  onButtonClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.buttonClickCallback) {
        columnDef.buttonClickCallback(e, rowData);
      }
    }
  };

  onRowClicked = (e) => {};

  onCheckBoxClick = (e, columnDef, rowData) => {
    this.props.onCheckBoxClick(e);
  };

  onCellCheckBoxClick = (e, columnDef, rowData) => {
    if (e && e.target) {
      if (!!columnDef.checkBoxClickCallback) {
        rowData[columnDef.columnBindingPropertyName] = e.target.value;
        columnDef.checkBoxClickCallback(e, rowData);
      }
    }
  };
  customStyles = {
    table: {
      style: {
        height: "400px",
        width: "100%",
        ScrollX: false,
        overflow: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "80%",
        borderCollapse: "collapse",
        verticalAlign: "middle !important",
        padding: "1px",
      },
    },
    header: {
      style: {
        display: "none",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        paddingTop: "5px",
        paddingBottom: "5px",
        // "&:not(:last-of-type)": {
        borderStyle: "solid",
        borderWidth: "0.5px",
        borderColor: "#fff",
        paddingLeft: "0",
        paddingRight: "0",
        // },
      },
    },
    // cells: {
    //   style: {
    //     // paddingTop: "5px",
    //     // paddingBottom: "5px",
    //     padding: "5px",
    //     borderRight: "2px solid #fff",
    //   },
    // },
    rows: {
      style: {
        minHeight: "20px",
      },
      denseStyle: {
        minHeight: "0px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#ddd",
        color: "#000",
      },
      stripedStyle: {
        color: "#000",
        backgroundColor: "#e9ecef",
      },
    },
    button: {
      default: "#5482AE",
    },
    headRow: {
      style: {
        backgroundColor: "#655f80",
        // paddingTop: "2px",
        // paddingBottom: "2px",
        minHeight: "2rem",
        // borderBottomWidth: "1px",
        // borderBottomColor: "#fff",
        // borderBottomStyle: "2px solid #fff",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        paddingRight: "1px",
        paddingLeft: "1px",
        borderRight: "2px solid #fff",
        textAlign: "center",
      },
      activeSortStyle: {
        color: "#fff",
        "&:focus": {
          outline: "none",
        },
        "&:hover:not(:focus)": {
          color: "#fff",
        },
        textAlign: "center",
      },
      inactiveSortStyle: {
        "&:focus": {
          outline: "none",
          color: "#fff",
        },
        "&:hover": {
          color: "#fff",
        },
        textAlign: "center",
      },
    },
  };
  render() {
    let dataGridColumnList = [];
    if (this.props.columnsList) {
      this.props.columnsList.map((cdef) =>
        dataGridColumnList.push(this.toDataGridColumn(cdef)),
      );
    }

    let noDataComponent = (
      <DataTableNoDataComponent isLoading={this.props.isLoading} />
    );

    return (
      <DataTable
        ref={this.componentRef}
        customStyles={this.props.customStyles}
        keys={this.props.keys}
        columns={dataGridColumnList}
        striped={true}
        highlightOnHover={true}
        data={this.props.dataList}
        noDataComponent={noDataComponent}
        onRowClicked={this.onRowClicked}
        persistTableHead
        selectableRows={this.props.selectableRows} // add for checkbox selection
        onSelectedRowsChange={this.onCheckBoxClick}
        selectableRowSelected={this.props.selectableRowSelected}
        disabled={this.props.disabled}
        // customStyles={this.props.customStyles}
        fixedHeader={this.props.fixedHeader}
      />
    );
  }
}

export {
  InputTextbox,
  InputCheckbox,
  CollapseComponent,
  LookupDialog,
  ShowError,
  ShowInfo,
  InputNumberTextbox,
};
